var e, t;

function r(e, t) {
  var r = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }

  return r;
}

function n(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? r(Object(n), !0).forEach(function (t) {
      a(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : r(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

function a(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}

function l(e) {
  return l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, l(e);
}

var s = {
  exports: {}
},
    c = {},
    o = Object.getOwnPropertySymbols,
    i = Object.prototype.hasOwnProperty,
    u = Object.prototype.propertyIsEnumerable;

function f(e) {
  if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(e);
}

var m = function () {
  try {
    if (!Object.assign) return !1;
    var e = new String("abc");
    if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

    for (var t = {}, r = 0; r < 10; r++) {
      t["_" + String.fromCharCode(r)] = r;
    }

    var n = Object.getOwnPropertyNames(t).map(function (e) {
      return t[e];
    });
    if ("0123456789" !== n.join("")) return !1;
    var a = {};
    return "abcdefghijklmnopqrst".split("").forEach(function (e) {
      a[e] = e;
    }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, a)).join("");
  } catch (e) {
    return !1;
  }
}() ? Object.assign : function (e, t) {
  for (var r, n, a = f(e), l = 1; l < arguments.length; l++) {
    for (var s in r = Object(arguments[l])) {
      i.call(r, s) && (a[s] = r[s]);
    }

    if (o) {
      n = o(r);

      for (var c = 0; c < n.length; c++) {
        u.call(r, n[c]) && (a[n[c]] = r[n[c]]);
      }
    }
  }

  return a;
},
    y = m,
    p = 60103,
    d = 60106;
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

c.Fragment = 60107, c.StrictMode = 60108, c.Profiler = 60114;
var v = 60109,
    h = 60110,
    g = 60112;
c.Suspense = 60113;
var E = 60115,
    b = 60116;

if ("function" == typeof Symbol && Symbol.for) {
  var w = Symbol.for;
  p = w("react.element"), d = w("react.portal"), c.Fragment = w("react.fragment"), c.StrictMode = w("react.strict_mode"), c.Profiler = w("react.profiler"), v = w("react.provider"), h = w("react.context"), g = w("react.forward_ref"), c.Suspense = w("react.suspense"), E = w("react.memo"), b = w("react.lazy");
}

var M = "function" == typeof Symbol && Symbol.iterator;

function x(e) {
  for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, r = 1; r < arguments.length; r++) {
    t += "&args[]=" + encodeURIComponent(arguments[r]);
  }

  return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}

var A = {
  isMounted: function isMounted() {
    return !1;
  },
  enqueueForceUpdate: function enqueueForceUpdate() {},
  enqueueReplaceState: function enqueueReplaceState() {},
  enqueueSetState: function enqueueSetState() {}
},
    k = {};

function _(e, t, r) {
  this.props = e, this.context = t, this.refs = k, this.updater = r || A;
}

function C() {}

function S(e, t, r) {
  this.props = e, this.context = t, this.refs = k, this.updater = r || A;
}

_.prototype.isReactComponent = {}, _.prototype.setState = function (e, t) {
  if ("object" !== l(e) && "function" != typeof e && null != e) throw Error(x(85));
  this.updater.enqueueSetState(this, e, t, "setState");
}, _.prototype.forceUpdate = function (e) {
  this.updater.enqueueForceUpdate(this, e, "forceUpdate");
}, C.prototype = _.prototype;
var I = S.prototype = new C();
I.constructor = S, y(I, _.prototype), I.isPureReactComponent = !0;
var O = {
  current: null
},
    j = Object.prototype.hasOwnProperty,
    P = {
  key: !0,
  ref: !0,
  __self: !0,
  __source: !0
};

function R(e, t, r) {
  var n,
      a = {},
      l = null,
      s = null;
  if (null != t) for (n in void 0 !== t.ref && (s = t.ref), void 0 !== t.key && (l = "" + t.key), t) {
    j.call(t, n) && !P.hasOwnProperty(n) && (a[n] = t[n]);
  }
  var c = arguments.length - 2;
  if (1 === c) a.children = r;else if (1 < c) {
    for (var o = Array(c), i = 0; i < c; i++) {
      o[i] = arguments[i + 2];
    }

    a.children = o;
  }
  if (e && e.defaultProps) for (n in c = e.defaultProps) {
    void 0 === a[n] && (a[n] = c[n]);
  }
  return {
    $$typeof: p,
    type: e,
    key: l,
    ref: s,
    props: a,
    _owner: O.current
  };
}

function B(e) {
  return "object" === l(e) && null !== e && e.$$typeof === p;
}

var V = /\/+/g;

function z(e, t) {
  return "object" === l(e) && null !== e && null != e.key ? function (e) {
    var t = {
      "=": "=0",
      ":": "=2"
    };
    return "$" + e.replace(/[=:]/g, function (e) {
      return t[e];
    });
  }("" + e.key) : t.toString(36);
}

function $(e, t, r, n, a) {
  var s = l(e);
  "undefined" !== s && "boolean" !== s || (e = null);
  var c = !1;
  if (null === e) c = !0;else switch (s) {
    case "string":
    case "number":
      c = !0;
      break;

    case "object":
      switch (e.$$typeof) {
        case p:
        case d:
          c = !0;
      }

  }
  if (c) return a = a(c = e), e = "" === n ? "." + z(c, 0) : n, Array.isArray(a) ? (r = "", null != e && (r = e.replace(V, "$&/") + "/"), $(a, t, r, "", function (e) {
    return e;
  })) : null != a && (B(a) && (a = function (e, t) {
    return {
      $$typeof: p,
      type: e.type,
      key: t,
      ref: e.ref,
      props: e.props,
      _owner: e._owner
    };
  }(a, r + (!a.key || c && c.key === a.key ? "" : ("" + a.key).replace(V, "$&/") + "/") + e)), t.push(a)), 1;
  if (c = 0, n = "" === n ? "." : n + ":", Array.isArray(e)) for (var o = 0; o < e.length; o++) {
    var i = n + z(s = e[o], o);
    c += $(s, t, r, i, a);
  } else if (i = function (e) {
    return null === e || "object" !== l(e) ? null : "function" == typeof (e = M && e[M] || e["@@iterator"]) ? e : null;
  }(e), "function" == typeof i) for (e = i.call(e), o = 0; !(s = e.next()).done;) {
    c += $(s = s.value, t, r, i = n + z(s, o++), a);
  } else if ("object" === s) throw t = "" + e, Error(x(31, "[object Object]" === t ? "object with keys {" + Object.keys(e).join(", ") + "}" : t));
  return c;
}

function H(e, t, r) {
  if (null == e) return e;
  var n = [],
      a = 0;
  return $(e, n, "", "", function (e) {
    return t.call(r, e, a++);
  }), n;
}

function L(e) {
  if (-1 === e._status) {
    var t = e._result;
    t = t(), e._status = 0, e._result = t, t.then(function (t) {
      0 === e._status && (t = t.default, e._status = 1, e._result = t);
    }, function (t) {
      0 === e._status && (e._status = 2, e._result = t);
    });
  }

  if (1 === e._status) return e._result;
  throw e._result;
}

var Z = {
  current: null
};

function T() {
  var e = Z.current;
  if (null === e) throw Error(x(321));
  return e;
}

var N = {
  ReactCurrentDispatcher: Z,
  ReactCurrentBatchConfig: {
    transition: 0
  },
  ReactCurrentOwner: O,
  IsSomeRendererActing: {
    current: !1
  },
  assign: y
};
c.Children = {
  map: H,
  forEach: function forEach(e, t, r) {
    H(e, function () {
      t.apply(this, arguments);
    }, r);
  },
  count: function count(e) {
    var t = 0;
    return H(e, function () {
      t++;
    }), t;
  },
  toArray: function toArray(e) {
    return H(e, function (e) {
      return e;
    }) || [];
  },
  only: function only(e) {
    if (!B(e)) throw Error(x(143));
    return e;
  }
}, c.Component = _, c.PureComponent = S, c.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = N, c.cloneElement = function (e, t, r) {
  if (null == e) throw Error(x(267, e));
  var n = y({}, e.props),
      a = e.key,
      l = e.ref,
      s = e._owner;

  if (null != t) {
    if (void 0 !== t.ref && (l = t.ref, s = O.current), void 0 !== t.key && (a = "" + t.key), e.type && e.type.defaultProps) var c = e.type.defaultProps;

    for (o in t) {
      j.call(t, o) && !P.hasOwnProperty(o) && (n[o] = void 0 === t[o] && void 0 !== c ? c[o] : t[o]);
    }
  }

  var o = arguments.length - 2;
  if (1 === o) n.children = r;else if (1 < o) {
    c = Array(o);

    for (var i = 0; i < o; i++) {
      c[i] = arguments[i + 2];
    }

    n.children = c;
  }
  return {
    $$typeof: p,
    type: e.type,
    key: a,
    ref: l,
    props: n,
    _owner: s
  };
}, c.createContext = function (e, t) {
  return void 0 === t && (t = null), (e = {
    $$typeof: h,
    _calculateChangedBits: t,
    _currentValue: e,
    _currentValue2: e,
    _threadCount: 0,
    Provider: null,
    Consumer: null
  }).Provider = {
    $$typeof: v,
    _context: e
  }, e.Consumer = e;
}, c.createElement = R, c.createFactory = function (e) {
  var t = R.bind(null, e);
  return t.type = e, t;
}, c.createRef = function () {
  return {
    current: null
  };
}, c.forwardRef = function (e) {
  return {
    $$typeof: g,
    render: e
  };
}, c.isValidElement = B, c.lazy = function (e) {
  return {
    $$typeof: b,
    _payload: {
      _status: -1,
      _result: e
    },
    _init: L
  };
}, c.memo = function (e, t) {
  return {
    $$typeof: E,
    type: e,
    compare: void 0 === t ? null : t
  };
}, c.useCallback = function (e, t) {
  return T().useCallback(e, t);
}, c.useContext = function (e, t) {
  return T().useContext(e, t);
}, c.useDebugValue = function () {}, c.useEffect = function (e, t) {
  return T().useEffect(e, t);
}, c.useImperativeHandle = function (e, t, r) {
  return T().useImperativeHandle(e, t, r);
}, c.useLayoutEffect = function (e, t) {
  return T().useLayoutEffect(e, t);
}, c.useMemo = function (e, t) {
  return T().useMemo(e, t);
}, c.useReducer = function (e, t, r) {
  return T().useReducer(e, t, r);
}, c.useRef = function (e) {
  return T().useRef(e);
}, c.useState = function (e) {
  return T().useState(e);
}, c.version = "17.0.2";
var D,
    F = {};
/** @license React v17.0.2
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

D = F, "production" !== process.env.NODE_ENV && function () {
  var e = m,
      t = 60103,
      r = 60106;
  D.Fragment = 60107, D.StrictMode = 60108, D.Profiler = 60114;
  var n = 60109,
      a = 60110,
      s = 60112;
  D.Suspense = 60113;
  var c = 60120,
      o = 60115,
      i = 60116,
      u = 60121,
      f = 60122,
      y = 60117,
      p = 60129,
      d = 60131;

  if ("function" == typeof Symbol && Symbol.for) {
    var v = Symbol.for;
    t = v("react.element"), r = v("react.portal"), D.Fragment = v("react.fragment"), D.StrictMode = v("react.strict_mode"), D.Profiler = v("react.profiler"), n = v("react.provider"), a = v("react.context"), s = v("react.forward_ref"), D.Suspense = v("react.suspense"), c = v("react.suspense_list"), o = v("react.memo"), i = v("react.lazy"), u = v("react.block"), f = v("react.server.block"), y = v("react.fundamental"), v("react.scope"), v("react.opaque.id"), p = v("react.debug_trace_mode"), v("react.offscreen"), d = v("react.legacy_hidden");
  }

  var h = "function" == typeof Symbol && Symbol.iterator;

  function g(e) {
    if (null === e || "object" !== l(e)) return null;
    var t = h && e[h] || e["@@iterator"];
    return "function" == typeof t ? t : null;
  }

  var E = {
    current: null
  },
      b = {
    current: null
  },
      w = {},
      M = null;

  function x(e) {
    M = e;
  }

  w.setExtraStackFrame = function (e) {
    M = e;
  }, w.getCurrentStack = null, w.getStackAddendum = function () {
    var e = "";
    M && (e += M);
    var t = w.getCurrentStack;
    return t && (e += t() || ""), e;
  };
  var A = {
    ReactCurrentDispatcher: E,
    ReactCurrentBatchConfig: {
      transition: 0
    },
    ReactCurrentOwner: b,
    IsSomeRendererActing: {
      current: !1
    },
    assign: e
  };

  function k(e) {
    for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) {
      r[n - 1] = arguments[n];
    }

    C("warn", e, r);
  }

  function _(e) {
    for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) {
      r[n - 1] = arguments[n];
    }

    C("error", e, r);
  }

  function C(e, t, r) {
    var n = A.ReactDebugCurrentFrame.getStackAddendum();
    "" !== n && (t += "%s", r = r.concat([n]));
    var a = r.map(function (e) {
      return "" + e;
    });
    a.unshift("Warning: " + t), Function.prototype.apply.call(console[e], console, a);
  }

  A.ReactDebugCurrentFrame = w;
  var S = {};

  function I(e, t) {
    var r = e.constructor,
        n = r && (r.displayName || r.name) || "ReactClass",
        a = n + "." + t;
    S[a] || (_("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", t, n), S[a] = !0);
  }

  var O = {
    isMounted: function isMounted(e) {
      return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate(e, t, r) {
      I(e, "forceUpdate");
    },
    enqueueReplaceState: function enqueueReplaceState(e, t, r, n) {
      I(e, "replaceState");
    },
    enqueueSetState: function enqueueSetState(e, t, r, n) {
      I(e, "setState");
    }
  },
      j = {};

  function P(e, t, r) {
    this.props = e, this.context = t, this.refs = j, this.updater = r || O;
  }

  Object.freeze(j), P.prototype.isReactComponent = {}, P.prototype.setState = function (e, t) {
    if ("object" !== l(e) && "function" != typeof e && null != e) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, e, t, "setState");
  }, P.prototype.forceUpdate = function (e) {
    this.updater.enqueueForceUpdate(this, e, "forceUpdate");
  };

  var R = {
    isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
    replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
  },
      B = function B(e, t) {
    Object.defineProperty(P.prototype, e, {
      get: function get() {
        k("%s(...) is deprecated in plain JavaScript React classes. %s", t[0], t[1]);
      }
    });
  };

  for (var V in R) {
    R.hasOwnProperty(V) && B(V, R[V]);
  }

  function z() {}

  function $(e, t, r) {
    this.props = e, this.context = t, this.refs = j, this.updater = r || O;
  }

  z.prototype = P.prototype;
  var H = $.prototype = new z();

  function L(e) {
    return e.displayName || "Context";
  }

  function Z(e) {
    if (null == e) return null;
    if ("number" == typeof e.tag && _("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), "function" == typeof e) return e.displayName || e.name || null;
    if ("string" == typeof e) return e;

    switch (e) {
      case D.Fragment:
        return "Fragment";

      case r:
        return "Portal";

      case D.Profiler:
        return "Profiler";

      case D.StrictMode:
        return "StrictMode";

      case D.Suspense:
        return "Suspense";

      case c:
        return "SuspenseList";
    }

    if ("object" === l(e)) switch (e.$$typeof) {
      case a:
        return L(e) + ".Consumer";

      case n:
        return L(e._context) + ".Provider";

      case s:
        return y = e, p = e.render, d = "ForwardRef", v = p.displayName || p.name || "", y.displayName || ("" !== v ? d + "(" + v + ")" : d);

      case o:
        return Z(e.type);

      case u:
        return Z(e._render);

      case i:
        var t = e,
            f = t._payload,
            m = t._init;

        try {
          return Z(m(f));
        } catch (e) {
          return null;
        }

    }
    var y, p, d, v;
    return null;
  }

  H.constructor = $, e(H, P.prototype), H.isPureReactComponent = !0;
  var T,
      N,
      F,
      U = Object.prototype.hasOwnProperty,
      q = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
  };

  function W(e) {
    if (U.call(e, "ref")) {
      var t = Object.getOwnPropertyDescriptor(e, "ref").get;
      if (t && t.isReactWarning) return !1;
    }

    return void 0 !== e.ref;
  }

  function Y(e) {
    if (U.call(e, "key")) {
      var t = Object.getOwnPropertyDescriptor(e, "key").get;
      if (t && t.isReactWarning) return !1;
    }

    return void 0 !== e.key;
  }

  function G(e, t) {
    var r = function r() {
      T || (T = !0, _("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", t));
    };

    r.isReactWarning = !0, Object.defineProperty(e, "key", {
      get: r,
      configurable: !0
    });
  }

  function J(e, t) {
    var r = function r() {
      N || (N = !0, _("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", t));
    };

    r.isReactWarning = !0, Object.defineProperty(e, "ref", {
      get: r,
      configurable: !0
    });
  }

  function X(e) {
    if ("string" == typeof e.ref && b.current && e.__self && b.current.stateNode !== e.__self) {
      var t = Z(b.current.type);
      F[t] || (_('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', t, e.ref), F[t] = !0);
    }
  }

  F = {};

  var K = function K(e, r, n, a, l, s, c) {
    var o = {
      $$typeof: t,
      type: e,
      key: r,
      ref: n,
      props: c,
      _owner: s,
      _store: {}
    };
    return Object.defineProperty(o._store, "validated", {
      configurable: !1,
      enumerable: !1,
      writable: !0,
      value: !1
    }), Object.defineProperty(o, "_self", {
      configurable: !1,
      enumerable: !1,
      writable: !1,
      value: a
    }), Object.defineProperty(o, "_source", {
      configurable: !1,
      enumerable: !1,
      writable: !1,
      value: l
    }), Object.freeze && (Object.freeze(o.props), Object.freeze(o)), o;
  };

  function Q(e, t, r) {
    var n,
        a = {},
        l = null,
        s = null,
        c = null,
        o = null;
    if (null != t) for (n in W(t) && (s = t.ref, X(t)), Y(t) && (l = "" + t.key), c = void 0 === t.__self ? null : t.__self, o = void 0 === t.__source ? null : t.__source, t) {
      U.call(t, n) && !q.hasOwnProperty(n) && (a[n] = t[n]);
    }
    var i = arguments.length - 2;
    if (1 === i) a.children = r;else if (i > 1) {
      for (var u = Array(i), f = 0; f < i; f++) {
        u[f] = arguments[f + 2];
      }

      Object.freeze && Object.freeze(u), a.children = u;
    }

    if (e && e.defaultProps) {
      var m = e.defaultProps;

      for (n in m) {
        void 0 === a[n] && (a[n] = m[n]);
      }
    }

    if (l || s) {
      var y = "function" == typeof e ? e.displayName || e.name || "Unknown" : e;
      l && G(a, y), s && J(a, y);
    }

    return K(e, l, s, c, o, b.current, a);
  }

  function ee(t, r, n) {
    if (null == t) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + t + ".");
    var a,
        l,
        s = e({}, t.props),
        c = t.key,
        o = t.ref,
        i = t._self,
        u = t._source,
        f = t._owner;
    if (null != r) for (a in W(r) && (o = r.ref, f = b.current), Y(r) && (c = "" + r.key), t.type && t.type.defaultProps && (l = t.type.defaultProps), r) {
      U.call(r, a) && !q.hasOwnProperty(a) && (void 0 === r[a] && void 0 !== l ? s[a] = l[a] : s[a] = r[a]);
    }
    var m = arguments.length - 2;
    if (1 === m) s.children = n;else if (m > 1) {
      for (var y = Array(m), p = 0; p < m; p++) {
        y[p] = arguments[p + 2];
      }

      s.children = y;
    }
    return K(t.type, c, o, i, u, f, s);
  }

  function te(e) {
    return "object" === l(e) && null !== e && e.$$typeof === t;
  }

  var re = !1,
      ne = /\/+/g;

  function ae(e) {
    return e.replace(ne, "$&/");
  }

  function le(e, t) {
    return "object" === l(e) && null !== e && null != e.key ? (r = "" + e.key, n = {
      "=": "=0",
      ":": "=2"
    }, "$" + r.replace(/[=:]/g, function (e) {
      return n[e];
    })) : t.toString(36);
    var r, n;
  }

  function se(e, n, a, s, c) {
    var o = l(e);
    "undefined" !== o && "boolean" !== o || (e = null);
    var i,
        u,
        f,
        m = !1;
    if (null === e) m = !0;else switch (o) {
      case "string":
      case "number":
        m = !0;
        break;

      case "object":
        switch (e.$$typeof) {
          case t:
          case r:
            m = !0;
        }

    }

    if (m) {
      var y = e,
          p = c(y),
          d = "" === s ? "." + le(y, 0) : s;

      if (Array.isArray(p)) {
        var v = "";
        null != d && (v = ae(d) + "/"), se(p, n, v, "", function (e) {
          return e;
        });
      } else null != p && (te(p) && (i = p, u = a + (!p.key || y && y.key === p.key ? "" : ae("" + p.key) + "/") + d, p = K(i.type, u, i.ref, i._self, i._source, i._owner, i.props)), n.push(p));

      return 1;
    }

    var h = 0,
        E = "" === s ? "." : s + ":";
    if (Array.isArray(e)) for (var b = 0; b < e.length; b++) {
      h += se(f = e[b], n, a, E + le(f, b), c);
    } else {
      var w = g(e);

      if ("function" == typeof w) {
        var M = e;
        w === M.entries && (re || k("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), re = !0);

        for (var x, A = w.call(M), _ = 0; !(x = A.next()).done;) {
          h += se(f = x.value, n, a, E + le(f, _++), c);
        }
      } else if ("object" === o) {
        var C = "" + e;
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === C ? "object with keys {" + Object.keys(e).join(", ") + "}" : C) + "). If you meant to render a collection of children, use an array instead.");
      }
    }
    return h;
  }

  function ce(e, t, r) {
    if (null == e) return e;
    var n = [],
        a = 0;
    return se(e, n, "", "", function (e) {
      return t.call(r, e, a++);
    }), n;
  }

  function oe(e) {
    if (-1 === e._status) {
      var t = (0, e._result)(),
          r = e;
      r._status = 0, r._result = t, t.then(function (t) {
        if (0 === e._status) {
          var r = t.default;
          void 0 === r && _("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", t);
          var n = e;
          n._status = 1, n._result = r;
        }
      }, function (t) {
        if (0 === e._status) {
          var r = e;
          r._status = 2, r._result = t;
        }
      });
    }

    if (1 === e._status) return e._result;
    throw e._result;
  }

  function ie(e) {
    return "string" == typeof e || "function" == typeof e || e === D.Fragment || e === D.Profiler || e === p || e === D.StrictMode || e === D.Suspense || e === c || e === d || "object" === l(e) && null !== e && (e.$$typeof === i || e.$$typeof === o || e.$$typeof === n || e.$$typeof === a || e.$$typeof === s || e.$$typeof === y || e.$$typeof === u || e[0] === f);
  }

  function ue() {
    var e = E.current;
    if (null === e) throw Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
    return e;
  }

  var fe,
      me,
      ye,
      pe,
      de,
      ve,
      he,
      ge = 0;

  function Ee() {}

  Ee.__reactDisabledLog = !0;
  var be,
      we = A.ReactCurrentDispatcher;

  function Me(e, t, r) {
    if (void 0 === be) try {
      throw Error();
    } catch (e) {
      var n = e.stack.trim().match(/\n( *(at )?)/);
      be = n && n[1] || "";
    }
    return "\n" + be + e;
  }

  var xe,
      Ae = !1,
      ke = "function" == typeof WeakMap ? WeakMap : Map;

  function _e(t, r) {
    if (!t || Ae) return "";
    var n,
        a = xe.get(t);
    if (void 0 !== a) return a;
    Ae = !0;
    var s,
        c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0, s = we.current, we.current = null, function () {
      if (0 === ge) {
        fe = console.log, me = console.info, ye = console.warn, pe = console.error, de = console.group, ve = console.groupCollapsed, he = console.groupEnd;
        var e = {
          configurable: !0,
          enumerable: !0,
          value: Ee,
          writable: !0
        };
        Object.defineProperties(console, {
          info: e,
          log: e,
          warn: e,
          error: e,
          group: e,
          groupCollapsed: e,
          groupEnd: e
        });
      }

      ge++;
    }();

    try {
      if (r) {
        var o = function o() {
          throw Error();
        };

        if (Object.defineProperty(o.prototype, "props", {
          set: function set() {
            throw Error();
          }
        }), "object" === ("undefined" == typeof Reflect ? "undefined" : l(Reflect)) && Reflect.construct) {
          try {
            Reflect.construct(o, []);
          } catch (e) {
            n = e;
          }

          Reflect.construct(t, [], o);
        } else {
          try {
            o.call();
          } catch (e) {
            n = e;
          }

          t.call(o.prototype);
        }
      } else {
        try {
          throw Error();
        } catch (e) {
          n = e;
        }

        t();
      }
    } catch (e) {
      if (e && n && "string" == typeof e.stack) {
        for (var i = e.stack.split("\n"), u = n.stack.split("\n"), f = i.length - 1, m = u.length - 1; f >= 1 && m >= 0 && i[f] !== u[m];) {
          m--;
        }

        for (; f >= 1 && m >= 0; f--, m--) {
          if (i[f] !== u[m]) {
            if (1 !== f || 1 !== m) do {
              if (f--, --m < 0 || i[f] !== u[m]) {
                var y = "\n" + i[f].replace(" at new ", " at ");
                return "function" == typeof t && xe.set(t, y), y;
              }
            } while (f >= 1 && m >= 0);
            break;
          }
        }
      }
    } finally {
      Ae = !1, we.current = s, function () {
        if (0 == --ge) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: e({}, t, {
              value: fe
            }),
            info: e({}, t, {
              value: me
            }),
            warn: e({}, t, {
              value: ye
            }),
            error: e({}, t, {
              value: pe
            }),
            group: e({}, t, {
              value: de
            }),
            groupCollapsed: e({}, t, {
              value: ve
            }),
            groupEnd: e({}, t, {
              value: he
            })
          });
        }

        ge < 0 && _("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }(), Error.prepareStackTrace = c;
    }

    var p = t ? t.displayName || t.name : "",
        d = p ? Me(p) : "";
    return "function" == typeof t && xe.set(t, d), d;
  }

  function Ce(e, t, r) {
    return _e(e, !1);
  }

  function Se(e, t, r) {
    if (null == e) return "";
    if ("function" == typeof e) return _e(e, function (e) {
      var t = e.prototype;
      return !(!t || !t.isReactComponent);
    }(e));
    if ("string" == typeof e) return Me(e);

    switch (e) {
      case D.Suspense:
        return Me("Suspense");

      case c:
        return Me("SuspenseList");
    }

    if ("object" === l(e)) switch (e.$$typeof) {
      case s:
        return Ce(e.render);

      case o:
        return Se(e.type, t, r);

      case u:
        return Ce(e._render);

      case i:
        var n = e,
            a = n._payload,
            f = n._init;

        try {
          return Se(f(a), t, r);
        } catch (e) {}

    }
    return "";
  }

  xe = new ke();
  var Ie,
      Oe = {},
      je = A.ReactDebugCurrentFrame;

  function Pe(e) {
    if (e) {
      var t = e._owner,
          r = Se(e.type, e._source, t ? t.type : null);
      je.setExtraStackFrame(r);
    } else je.setExtraStackFrame(null);
  }

  function Re(e) {
    if (e) {
      var t = e._owner;
      x(Se(e.type, e._source, t ? t.type : null));
    } else x(null);
  }

  function Be() {
    if (b.current) {
      var e = Z(b.current.type);
      if (e) return "\n\nCheck the render method of `" + e + "`.";
    }

    return "";
  }

  function Ve(e) {
    return null != e && void 0 !== (t = e.__source) ? "\n\nCheck your code at " + t.fileName.replace(/^.*[\\\/]/, "") + ":" + t.lineNumber + "." : "";
    var t;
  }

  Ie = !1;
  var ze = {};

  function $e(e, t) {
    if (e._store && !e._store.validated && null == e.key) {
      e._store.validated = !0;

      var r = function (e) {
        var t = Be();

        if (!t) {
          var r = "string" == typeof e ? e : e.displayName || e.name;
          r && (t = "\n\nCheck the top-level render call using <" + r + ">.");
        }

        return t;
      }(t);

      if (!ze[r]) {
        ze[r] = !0;
        var n = "";
        e && e._owner && e._owner !== b.current && (n = " It was passed a child from " + Z(e._owner.type) + "."), Re(e), _('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', r, n), Re(null);
      }
    }
  }

  function He(e, t) {
    if ("object" === l(e)) if (Array.isArray(e)) for (var r = 0; r < e.length; r++) {
      var n = e[r];
      te(n) && $e(n, t);
    } else if (te(e)) e._store && (e._store.validated = !0);else if (e) {
      var a = g(e);
      if ("function" == typeof a && a !== e.entries) for (var s, c = a.call(e); !(s = c.next()).done;) {
        te(s.value) && $e(s.value, t);
      }
    }
  }

  function Le(e) {
    var t,
        r = e.type;

    if (null != r && "string" != typeof r) {
      if ("function" == typeof r) t = r.propTypes;else {
        if ("object" !== l(r) || r.$$typeof !== s && r.$$typeof !== o) return;
        t = r.propTypes;
      }

      if (t) {
        var n = Z(r);
        !function (e, t, r, n, a) {
          var s = Function.call.bind(Object.prototype.hasOwnProperty);

          for (var c in e) {
            if (s(e, c)) {
              var o = void 0;

              try {
                if ("function" != typeof e[c]) {
                  var i = Error((n || "React class") + ": " + r + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + l(e[c]) + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw i.name = "Invariant Violation", i;
                }

                o = e[c](t, c, n, r, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (e) {
                o = e;
              }

              !o || o instanceof Error || (Pe(a), _("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", n || "React class", r, c, l(o)), Pe(null)), o instanceof Error && !(o.message in Oe) && (Oe[o.message] = !0, Pe(a), _("Failed %s type: %s", r, o.message), Pe(null));
            }
          }
        }(t, e.props, "prop", n, e);
      } else void 0 === r.PropTypes || Ie || (Ie = !0, _("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Z(r) || "Unknown"));

      "function" != typeof r.getDefaultProps || r.getDefaultProps.isReactClassApproved || _("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
  }

  function Ze(e) {
    for (var t = Object.keys(e.props), r = 0; r < t.length; r++) {
      var n = t[r];

      if ("children" !== n && "key" !== n) {
        Re(e), _("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", n), Re(null);
        break;
      }
    }

    null !== e.ref && (Re(e), _("Invalid attribute `ref` supplied to `React.Fragment`."), Re(null));
  }

  function Te(e, r, n) {
    var a = ie(e);

    if (!a) {
      var s = "";
      (void 0 === e || "object" === l(e) && null !== e && 0 === Object.keys(e).length) && (s += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
      var c,
          o = Ve(r);
      s += o || Be(), null === e ? c = "null" : Array.isArray(e) ? c = "array" : void 0 !== e && e.$$typeof === t ? (c = "<" + (Z(e.type) || "Unknown") + " />", s = " Did you accidentally export a JSX literal instead of a component?") : c = l(e), _("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", c, s);
    }

    var i = Q.apply(this, arguments);
    if (null == i) return i;
    if (a) for (var u = 2; u < arguments.length; u++) {
      He(arguments[u], e);
    }
    return e === D.Fragment ? Ze(i) : Le(i), i;
  }

  var Ne = !1;

  try {
    var De = Object.freeze({});
    new Map([[De, null]]), new Set([De]);
  } catch (e) {}

  var Fe = Te,
      Ue = function Ue(e, t, r) {
    for (var n = ee.apply(this, arguments), a = 2; a < arguments.length; a++) {
      He(arguments[a], n.type);
    }

    return Le(n), n;
  },
      qe = function qe(e) {
    var t = Te.bind(null, e);
    return t.type = e, Ne || (Ne = !0, k("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.")), Object.defineProperty(t, "type", {
      enumerable: !1,
      get: function get() {
        return k("Factory.type is deprecated. Access the class directly before passing it to createFactory."), Object.defineProperty(this, "type", {
          value: e
        }), e;
      }
    }), t;
  },
      We = {
    map: ce,
    forEach: function forEach(e, t, r) {
      ce(e, function () {
        t.apply(this, arguments);
      }, r);
    },
    count: function count(e) {
      var t = 0;
      return ce(e, function () {
        t++;
      }), t;
    },
    toArray: function toArray(e) {
      return ce(e, function (e) {
        return e;
      }) || [];
    },
    only: function only(e) {
      if (!te(e)) throw Error("React.Children.only expected to receive a single React element child.");
      return e;
    }
  };

  D.Children = We, D.Component = P, D.PureComponent = $, D.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = A, D.cloneElement = Ue, D.createContext = function (e, t) {
    void 0 === t ? t = null : null !== t && "function" != typeof t && _("createContext: Expected the optional second argument to be a function. Instead received: %s", t);
    var r = {
      $$typeof: a,
      _calculateChangedBits: t,
      _currentValue: e,
      _currentValue2: e,
      _threadCount: 0,
      Provider: null,
      Consumer: null
    };
    r.Provider = {
      $$typeof: n,
      _context: r
    };
    var l = !1,
        s = !1,
        c = !1,
        o = {
      $$typeof: a,
      _context: r,
      _calculateChangedBits: r._calculateChangedBits
    };
    return Object.defineProperties(o, {
      Provider: {
        get: function get() {
          return s || (s = !0, _("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?")), r.Provider;
        },
        set: function set(e) {
          r.Provider = e;
        }
      },
      _currentValue: {
        get: function get() {
          return r._currentValue;
        },
        set: function set(e) {
          r._currentValue = e;
        }
      },
      _currentValue2: {
        get: function get() {
          return r._currentValue2;
        },
        set: function set(e) {
          r._currentValue2 = e;
        }
      },
      _threadCount: {
        get: function get() {
          return r._threadCount;
        },
        set: function set(e) {
          r._threadCount = e;
        }
      },
      Consumer: {
        get: function get() {
          return l || (l = !0, _("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?")), r.Consumer;
        }
      },
      displayName: {
        get: function get() {
          return r.displayName;
        },
        set: function set(e) {
          c || (k("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", e), c = !0);
        }
      }
    }), r.Consumer = o, r._currentRenderer = null, r._currentRenderer2 = null, r;
  }, D.createElement = Fe, D.createFactory = qe, D.createRef = function () {
    var e = {
      current: null
    };
    return Object.seal(e), e;
  }, D.forwardRef = function (e) {
    null != e && e.$$typeof === o ? _("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : "function" != typeof e ? _("forwardRef requires a render function but was given %s.", null === e ? "null" : l(e)) : 0 !== e.length && 2 !== e.length && _("forwardRef render functions accept exactly two parameters: props and ref. %s", 1 === e.length ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."), null != e && (null == e.defaultProps && null == e.propTypes || _("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?"));
    var t,
        r = {
      $$typeof: s,
      render: e
    };
    return Object.defineProperty(r, "displayName", {
      enumerable: !1,
      configurable: !0,
      get: function get() {
        return t;
      },
      set: function set(r) {
        t = r, null == e.displayName && (e.displayName = r);
      }
    }), r;
  }, D.isValidElement = te, D.lazy = function (e) {
    var t,
        r,
        n = {
      $$typeof: i,
      _payload: {
        _status: -1,
        _result: e
      },
      _init: oe
    };
    return Object.defineProperties(n, {
      defaultProps: {
        configurable: !0,
        get: function get() {
          return t;
        },
        set: function set(e) {
          _("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), t = e, Object.defineProperty(n, "defaultProps", {
            enumerable: !0
          });
        }
      },
      propTypes: {
        configurable: !0,
        get: function get() {
          return r;
        },
        set: function set(e) {
          _("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), r = e, Object.defineProperty(n, "propTypes", {
            enumerable: !0
          });
        }
      }
    }), n;
  }, D.memo = function (e, t) {
    ie(e) || _("memo: The first argument must be a component. Instead received: %s", null === e ? "null" : l(e));
    var r,
        n = {
      $$typeof: o,
      type: e,
      compare: void 0 === t ? null : t
    };
    return Object.defineProperty(n, "displayName", {
      enumerable: !1,
      configurable: !0,
      get: function get() {
        return r;
      },
      set: function set(t) {
        r = t, null == e.displayName && (e.displayName = t);
      }
    }), n;
  }, D.useCallback = function (e, t) {
    return ue().useCallback(e, t);
  }, D.useContext = function (e, t) {
    var r = ue();

    if (void 0 !== t && _("useContext() second argument is reserved for future use in React. Passing it is not supported. You passed: %s.%s", t, "number" == typeof t && Array.isArray(arguments[2]) ? "\n\nDid you call array.map(useContext)? Calling Hooks inside a loop is not supported. Learn more at https://reactjs.org/link/rules-of-hooks" : ""), void 0 !== e._context) {
      var n = e._context;
      n.Consumer === e ? _("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?") : n.Provider === e && _("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
    }

    return r.useContext(e, t);
  }, D.useDebugValue = function (e, t) {
    return ue().useDebugValue(e, t);
  }, D.useEffect = function (e, t) {
    return ue().useEffect(e, t);
  }, D.useImperativeHandle = function (e, t, r) {
    return ue().useImperativeHandle(e, t, r);
  }, D.useLayoutEffect = function (e, t) {
    return ue().useLayoutEffect(e, t);
  }, D.useMemo = function (e, t) {
    return ue().useMemo(e, t);
  }, D.useReducer = function (e, t, r) {
    return ue().useReducer(e, t, r);
  }, D.useRef = function (e) {
    return ue().useRef(e);
  }, D.useState = function (e) {
    return ue().useState(e);
  }, D.version = "17.0.2";
}(), "production" === process.env.NODE_ENV ? s.exports = c : s.exports = F;
var U = s.exports,
    q = {
  exports: {}
},
    W = {
  exports: {}
},
    Y = {},
    G = "function" == typeof Symbol && Symbol.for,
    J = G ? Symbol.for("react.element") : 60103,
    X = G ? Symbol.for("react.portal") : 60106,
    K = G ? Symbol.for("react.fragment") : 60107,
    Q = G ? Symbol.for("react.strict_mode") : 60108,
    ee = G ? Symbol.for("react.profiler") : 60114,
    te = G ? Symbol.for("react.provider") : 60109,
    re = G ? Symbol.for("react.context") : 60110,
    ne = G ? Symbol.for("react.async_mode") : 60111,
    ae = G ? Symbol.for("react.concurrent_mode") : 60111,
    le = G ? Symbol.for("react.forward_ref") : 60112,
    se = G ? Symbol.for("react.suspense") : 60113,
    ce = G ? Symbol.for("react.suspense_list") : 60120,
    oe = G ? Symbol.for("react.memo") : 60115,
    ie = G ? Symbol.for("react.lazy") : 60116,
    ue = G ? Symbol.for("react.block") : 60121,
    fe = G ? Symbol.for("react.fundamental") : 60117,
    me = G ? Symbol.for("react.responder") : 60118,
    ye = G ? Symbol.for("react.scope") : 60119;

function pe(e) {
  if ("object" === l(e) && null !== e) {
    var t = e.$$typeof;

    switch (t) {
      case J:
        switch (e = e.type) {
          case ne:
          case ae:
          case K:
          case ee:
          case Q:
          case se:
            return e;

          default:
            switch (e = e && e.$$typeof) {
              case re:
              case le:
              case ie:
              case oe:
              case te:
                return e;

              default:
                return t;
            }

        }

      case X:
        return t;
    }
  }
}

function de(e) {
  return pe(e) === ae;
}

Y.AsyncMode = ne, Y.ConcurrentMode = ae, Y.ContextConsumer = re, Y.ContextProvider = te, Y.Element = J, Y.ForwardRef = le, Y.Fragment = K, Y.Lazy = ie, Y.Memo = oe, Y.Portal = X, Y.Profiler = ee, Y.StrictMode = Q, Y.Suspense = se, Y.isAsyncMode = function (e) {
  return de(e) || pe(e) === ne;
}, Y.isConcurrentMode = de, Y.isContextConsumer = function (e) {
  return pe(e) === re;
}, Y.isContextProvider = function (e) {
  return pe(e) === te;
}, Y.isElement = function (e) {
  return "object" === l(e) && null !== e && e.$$typeof === J;
}, Y.isForwardRef = function (e) {
  return pe(e) === le;
}, Y.isFragment = function (e) {
  return pe(e) === K;
}, Y.isLazy = function (e) {
  return pe(e) === ie;
}, Y.isMemo = function (e) {
  return pe(e) === oe;
}, Y.isPortal = function (e) {
  return pe(e) === X;
}, Y.isProfiler = function (e) {
  return pe(e) === ee;
}, Y.isStrictMode = function (e) {
  return pe(e) === Q;
}, Y.isSuspense = function (e) {
  return pe(e) === se;
}, Y.isValidElementType = function (e) {
  return "string" == typeof e || "function" == typeof e || e === K || e === ae || e === ee || e === Q || e === se || e === ce || "object" === l(e) && null !== e && (e.$$typeof === ie || e.$$typeof === oe || e.$$typeof === te || e.$$typeof === re || e.$$typeof === le || e.$$typeof === fe || e.$$typeof === me || e.$$typeof === ye || e.$$typeof === ue);
}, Y.typeOf = pe;
var ve = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

"production" !== process.env.NODE_ENV && function () {
  var e = "function" == typeof Symbol && Symbol.for,
      t = e ? Symbol.for("react.element") : 60103,
      r = e ? Symbol.for("react.portal") : 60106,
      n = e ? Symbol.for("react.fragment") : 60107,
      a = e ? Symbol.for("react.strict_mode") : 60108,
      s = e ? Symbol.for("react.profiler") : 60114,
      c = e ? Symbol.for("react.provider") : 60109,
      o = e ? Symbol.for("react.context") : 60110,
      i = e ? Symbol.for("react.async_mode") : 60111,
      u = e ? Symbol.for("react.concurrent_mode") : 60111,
      f = e ? Symbol.for("react.forward_ref") : 60112,
      m = e ? Symbol.for("react.suspense") : 60113,
      y = e ? Symbol.for("react.suspense_list") : 60120,
      p = e ? Symbol.for("react.memo") : 60115,
      d = e ? Symbol.for("react.lazy") : 60116,
      v = e ? Symbol.for("react.block") : 60121,
      h = e ? Symbol.for("react.fundamental") : 60117,
      g = e ? Symbol.for("react.responder") : 60118,
      E = e ? Symbol.for("react.scope") : 60119;

  function b(e) {
    if ("object" === l(e) && null !== e) {
      var y = e.$$typeof;

      switch (y) {
        case t:
          var v = e.type;

          switch (v) {
            case i:
            case u:
            case n:
            case s:
            case a:
            case m:
              return v;

            default:
              var h = v && v.$$typeof;

              switch (h) {
                case o:
                case f:
                case d:
                case p:
                case c:
                  return h;

                default:
                  return y;
              }

          }

        case r:
          return y;
      }
    }
  }

  var w = i,
      M = u,
      x = o,
      A = c,
      k = t,
      _ = f,
      C = n,
      S = d,
      I = p,
      O = r,
      j = s,
      P = a,
      R = m,
      B = !1;

  function V(e) {
    return b(e) === u;
  }

  ve.AsyncMode = w, ve.ConcurrentMode = M, ve.ContextConsumer = x, ve.ContextProvider = A, ve.Element = k, ve.ForwardRef = _, ve.Fragment = C, ve.Lazy = S, ve.Memo = I, ve.Portal = O, ve.Profiler = j, ve.StrictMode = P, ve.Suspense = R, ve.isAsyncMode = function (e) {
    return B || (B = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), V(e) || b(e) === i;
  }, ve.isConcurrentMode = V, ve.isContextConsumer = function (e) {
    return b(e) === o;
  }, ve.isContextProvider = function (e) {
    return b(e) === c;
  }, ve.isElement = function (e) {
    return "object" === l(e) && null !== e && e.$$typeof === t;
  }, ve.isForwardRef = function (e) {
    return b(e) === f;
  }, ve.isFragment = function (e) {
    return b(e) === n;
  }, ve.isLazy = function (e) {
    return b(e) === d;
  }, ve.isMemo = function (e) {
    return b(e) === p;
  }, ve.isPortal = function (e) {
    return b(e) === r;
  }, ve.isProfiler = function (e) {
    return b(e) === s;
  }, ve.isStrictMode = function (e) {
    return b(e) === a;
  }, ve.isSuspense = function (e) {
    return b(e) === m;
  }, ve.isValidElementType = function (e) {
    return "string" == typeof e || "function" == typeof e || e === n || e === u || e === s || e === a || e === m || e === y || "object" === l(e) && null !== e && (e.$$typeof === d || e.$$typeof === p || e.$$typeof === c || e.$$typeof === o || e.$$typeof === f || e.$$typeof === h || e.$$typeof === g || e.$$typeof === E || e.$$typeof === v);
  }, ve.typeOf = b;
}(), "production" === process.env.NODE_ENV ? W.exports = Y : W.exports = ve;

var he = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
    ge = Function.call.bind(Object.prototype.hasOwnProperty),
    Ee = function Ee() {};

if ("production" !== process.env.NODE_ENV) {
  var be = he,
      we = {},
      Me = ge;

  Ee = function Ee(e) {
    var t = "Warning: " + e;
    "undefined" != typeof console && console.error(t);

    try {
      throw new Error(t);
    } catch (e) {}
  };
}

function xe(e, t, r, n, a) {
  if ("production" !== process.env.NODE_ENV) for (var s in e) {
    if (Me(e, s)) {
      var c;

      try {
        if ("function" != typeof e[s]) {
          var o = Error((n || "React class") + ": " + r + " type `" + s + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + l(e[s]) + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
          throw o.name = "Invariant Violation", o;
        }

        c = e[s](t, s, n, r, null, be);
      } catch (e) {
        c = e;
      }

      if (!c || c instanceof Error || Ee((n || "React class") + ": type specification of " + r + " `" + s + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + l(c) + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), c instanceof Error && !(c.message in we)) {
        we[c.message] = !0;
        var i = a ? a() : "";
        Ee("Failed " + r + " type: " + c.message + (null != i ? i : ""));
      }
    }
  }
}

xe.resetWarningCache = function () {
  "production" !== process.env.NODE_ENV && (we = {});
};

var Ae = xe,
    ke = W.exports,
    _e = m,
    Ce = he,
    Se = ge,
    Ie = Ae,
    Oe = function Oe() {};

function je() {
  return null;
}

"production" !== process.env.NODE_ENV && (Oe = function Oe(e) {
  var t = "Warning: " + e;
  "undefined" != typeof console && console.error(t);

  try {
    throw new Error(t);
  } catch (e) {}
});

function Pe() {}

function Re() {}

Re.resetWarningCache = Pe;

if ("production" !== process.env.NODE_ENV) {
  var Be = W.exports;

  q.exports = function (e, t) {
    var r = "function" == typeof Symbol && Symbol.iterator,
        n = "<<anonymous>>",
        a = {
      array: i("array"),
      bigint: i("bigint"),
      bool: i("boolean"),
      func: i("function"),
      number: i("number"),
      object: i("object"),
      string: i("string"),
      symbol: i("symbol"),
      any: o(je),
      arrayOf: function arrayOf(e) {
        return o(function (t, r, n, a, l) {
          if ("function" != typeof e) return new c("Property `" + l + "` of component `" + n + "` has invalid PropType notation inside arrayOf.");
          var s = t[r];
          if (!Array.isArray(s)) return new c("Invalid " + a + " `" + l + "` of type `" + m(s) + "` supplied to `" + n + "`, expected an array.");

          for (var o = 0; o < s.length; o++) {
            var i = e(s, o, n, a, l + "[" + o + "]", Ce);
            if (i instanceof Error) return i;
          }

          return null;
        });
      },
      element: o(function (t, r, n, a, l) {
        var s = t[r];
        return e(s) ? null : new c("Invalid " + a + " `" + l + "` of type `" + m(s) + "` supplied to `" + n + "`, expected a single ReactElement.");
      }),
      elementType: o(function (e, t, r, n, a) {
        var l = e[t];
        return ke.isValidElementType(l) ? null : new c("Invalid " + n + " `" + a + "` of type `" + m(l) + "` supplied to `" + r + "`, expected a single ReactElement type.");
      }),
      instanceOf: function instanceOf(e) {
        return o(function (t, r, a, l, s) {
          if (!(t[r] instanceof e)) {
            var o = e.name || n;
            return new c("Invalid " + l + " `" + s + "` of type `" + ((i = t[r]).constructor && i.constructor.name ? i.constructor.name : n) + "` supplied to `" + a + "`, expected instance of `" + o + "`.");
          }

          var i;
          return null;
        });
      },
      node: o(function (e, t, r, n, a) {
        return f(e[t]) ? null : new c("Invalid " + n + " `" + a + "` supplied to `" + r + "`, expected a ReactNode.");
      }),
      objectOf: function objectOf(e) {
        return o(function (t, r, n, a, l) {
          if ("function" != typeof e) return new c("Property `" + l + "` of component `" + n + "` has invalid PropType notation inside objectOf.");
          var s = t[r],
              o = m(s);
          if ("object" !== o) return new c("Invalid " + a + " `" + l + "` of type `" + o + "` supplied to `" + n + "`, expected an object.");

          for (var i in s) {
            if (Se(s, i)) {
              var u = e(s, i, n, a, l + "." + i, Ce);
              if (u instanceof Error) return u;
            }
          }

          return null;
        });
      },
      oneOf: function oneOf(e) {
        if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && Oe(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), je;

        function t(t, r, n, a, l) {
          for (var o = t[r], i = 0; i < e.length; i++) {
            if (s(o, e[i])) return null;
          }

          var u = JSON.stringify(e, function (e, t) {
            return "symbol" === y(t) ? String(t) : t;
          });
          return new c("Invalid " + a + " `" + l + "` of value `" + String(o) + "` supplied to `" + n + "`, expected one of " + u + ".");
        }

        return o(t);
      },
      oneOfType: function oneOfType(e) {
        if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && Oe("Invalid argument supplied to oneOfType, expected an instance of array."), je;

        for (var t = 0; t < e.length; t++) {
          var r = e[t];
          if ("function" != typeof r) return Oe("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + p(r) + " at index " + t + "."), je;
        }

        return o(function (t, r, n, a, l) {
          for (var s = [], o = 0; o < e.length; o++) {
            var i = (0, e[o])(t, r, n, a, l, Ce);
            if (null == i) return null;
            i.data && Se(i.data, "expectedType") && s.push(i.data.expectedType);
          }

          return new c("Invalid " + a + " `" + l + "` supplied to `" + n + "`" + (s.length > 0 ? ", expected one of type [" + s.join(", ") + "]" : "") + ".");
        });
      },
      shape: function shape(e) {
        return o(function (t, r, n, a, l) {
          var s = t[r],
              o = m(s);
          if ("object" !== o) return new c("Invalid " + a + " `" + l + "` of type `" + o + "` supplied to `" + n + "`, expected `object`.");

          for (var i in e) {
            var f = e[i];
            if ("function" != typeof f) return u(n, a, l, i, y(f));
            var p = f(s, i, n, a, l + "." + i, Ce);
            if (p) return p;
          }

          return null;
        });
      },
      exact: function exact(e) {
        return o(function (t, r, n, a, l) {
          var s = t[r],
              o = m(s);
          if ("object" !== o) return new c("Invalid " + a + " `" + l + "` of type `" + o + "` supplied to `" + n + "`, expected `object`.");

          var i = _e({}, t[r], e);

          for (var f in i) {
            var p = e[f];
            if (Se(e, f) && "function" != typeof p) return u(n, a, l, f, y(p));
            if (!p) return new c("Invalid " + a + " `" + l + "` key `" + f + "` supplied to `" + n + "`.\nBad object: " + JSON.stringify(t[r], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
            var d = p(s, f, n, a, l + "." + f, Ce);
            if (d) return d;
          }

          return null;
        });
      }
    };

    function s(e, t) {
      return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
    }

    function c(e, t) {
      this.message = e, this.data = t && "object" === l(t) ? t : {}, this.stack = "";
    }

    function o(e) {
      if ("production" !== process.env.NODE_ENV) var r = {},
          a = 0;

      function l(l, s, o, i, u, f, m) {
        if (i = i || n, f = f || o, m !== Ce) {
          if (t) {
            var y = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
            throw y.name = "Invariant Violation", y;
          }

          if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
            var p = i + ":" + o;
            !r[p] && a < 3 && (Oe("You are manually calling a React.PropTypes validation function for the `" + f + "` prop on `" + i + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), r[p] = !0, a++);
          }
        }

        return null == s[o] ? l ? null === s[o] ? new c("The " + u + " `" + f + "` is marked as required in `" + i + "`, but its value is `null`.") : new c("The " + u + " `" + f + "` is marked as required in `" + i + "`, but its value is `undefined`.") : null : e(s, o, i, u, f);
      }

      var s = l.bind(null, !1);
      return s.isRequired = l.bind(null, !0), s;
    }

    function i(e) {
      return o(function (t, r, n, a, l, s) {
        var o = t[r];
        return m(o) !== e ? new c("Invalid " + a + " `" + l + "` of type `" + y(o) + "` supplied to `" + n + "`, expected `" + e + "`.", {
          expectedType: e
        }) : null;
      });
    }

    function u(e, t, r, n, a) {
      return new c((e || "React class") + ": " + t + " type `" + r + "." + n + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + a + "`.");
    }

    function f(t) {
      switch (l(t)) {
        case "number":
        case "string":
        case "undefined":
          return !0;

        case "boolean":
          return !t;

        case "object":
          if (Array.isArray(t)) return t.every(f);
          if (null === t || e(t)) return !0;

          var n = function (e) {
            var t = e && (r && e[r] || e["@@iterator"]);
            if ("function" == typeof t) return t;
          }(t);

          if (!n) return !1;
          var a,
              s = n.call(t);

          if (n !== t.entries) {
            for (; !(a = s.next()).done;) {
              if (!f(a.value)) return !1;
            }
          } else for (; !(a = s.next()).done;) {
            var c = a.value;
            if (c && !f(c[1])) return !1;
          }

          return !0;

        default:
          return !1;
      }
    }

    function m(e) {
      var t = l(e);
      return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : function (e, t) {
        return "symbol" === e || !!t && ("Symbol" === t["@@toStringTag"] || "function" == typeof Symbol && t instanceof Symbol);
      }(t, e) ? "symbol" : t;
    }

    function y(e) {
      if (null == e) return "" + e;
      var t = m(e);

      if ("object" === t) {
        if (e instanceof Date) return "date";
        if (e instanceof RegExp) return "regexp";
      }

      return t;
    }

    function p(e) {
      var t = y(e);

      switch (t) {
        case "array":
        case "object":
          return "an " + t;

        case "boolean":
        case "date":
        case "regexp":
          return "a " + t;

        default:
          return t;
      }
    }

    return c.prototype = Error.prototype, a.checkPropTypes = Ie, a.resetWarningCache = Ie.resetWarningCache, a.PropTypes = a, a;
  }(Be.isElement, !0);
} else q.exports = function () {
  function e(e, t, r, n, a, l) {
    if ("SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED" !== l) {
      var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      throw s.name = "Invariant Violation", s;
    }
  }

  function t() {
    return e;
  }

  e.isRequired = e;
  var r = {
    array: e,
    bigint: e,
    bool: e,
    func: e,
    number: e,
    object: e,
    string: e,
    symbol: e,
    any: e,
    arrayOf: t,
    element: e,
    elementType: e,
    instanceOf: t,
    node: e,
    objectOf: t,
    oneOf: t,
    oneOfType: t,
    shape: t,
    exact: t,
    checkPropTypes: Re,
    resetWarningCache: Pe
  };
  return r.PropTypes = r, r;
}();

var Ve = q.exports,
    ze = "#0F191B",
    $e = {
  svg: {
    width: "100%",
    height: "100%"
  },
  bg: {
    opacity: 1,
    fill: "transparent",
    width: "28px",
    height: "28px"
  },
  line: {
    fill: "none",
    stroke: "#E84961",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5px"
  }
},
    He = {
  svg: {
    width: "100%",
    height: "100%"
  },
  bg: {
    opacity: 1,
    fill: "transparent",
    width: "28px",
    height: "28px"
  },
  line: {
    fill: "none",
    stroke: ze,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5px"
  }
},
    Le = {
  svg: {
    width: "100%",
    height: "100%"
  },
  bg: {
    opacity: 1,
    fill: "transparent",
    width: "28px",
    height: "28px"
  },
  line: {
    fill: ze
  }
},
    Ze = {
  svg: {
    width: "100%",
    height: "100%"
  },
  bg: {
    opacity: 1,
    fill: "transparent",
    width: "28px",
    height: "28px"
  },
  line: {
    fill: ze,
    strokeWidth: "0.5px",
    stroke: ze
  }
},
    Te = {
  svg: {
    width: "100%",
    height: "100%"
  },
  bg: {
    opacity: 1,
    fill: "transparent",
    width: "28px",
    height: "28px"
  },
  line: {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5px",
    stroke: "#388CFF"
  }
},
    Ne = {
  svg: {
    width: "100%",
    height: "100%"
  },
  bg: {
    opacity: 1,
    fill: "transparent",
    width: "28px",
    height: "28px"
  },
  line: {
    fill: "none",
    stroke: "#78d37f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5px"
  }
},
    De = {
  svg: {
    width: "100%",
    height: "100%"
  },
  bg: {
    opacity: 1,
    fill: "transparent",
    width: "32px",
    height: "32px"
  },
  line: {
    fill: "#3e3e3e"
  }
},
    Fe = {
  svg: {
    width: "100%",
    height: "100%"
  },
  bg: (e = {
    opacity: 1,
    fill: "none"
  }, a(e, "opacity", "0"), a(e, "width", "48px"), a(e, "height", "48px"), e),
  line: {
    fill: "#333"
  }
},
    Ue = {
  svg: {
    width: "100%",
    height: "100%"
  },
  bg: (t = {
    opacity: 1,
    fill: "none"
  }, a(t, "opacity", "0"), a(t, "width", "48px"), a(t, "height", "48px"), t),
  line: {
    fill: "none",
    stroke: "#0f191b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.2px"
  }
},
    qe = function qe(e) {
  var t = e.styles,
      r = n(n({}, Te), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("g", {
    transform: "translate(3.5 3.5)"
  }, U.createElement("path", {
    style: r.line,
    d: "M20,13.166v7A2.333,2.333,0,0,1,17.666,22.5H4.834A2.333,2.333,0,0,1,2.5,20.166V7.334A2.333,2.333,0,0,1,4.834,5h7",
    transform: "translate(-2.5 -1.5)"
  }), U.createElement("path", {
    style: r.line,
    d: "M12.5,2.5h7v7",
    transform: "translate(1.5 -2.5)"
  }), U.createElement("line", {
    style: r.line,
    y1: "12.833",
    x2: "12.833",
    transform: "translate(8.167)"
  })));
},
    We = function We(e) {
  var t = e.styles,
      r = n(n({}, Te), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("g", {
    transform: "translate(3.5 2.334)"
  }, U.createElement("path", {
    style: r.line,
    d: "M2.5,5h21",
    transform: "translate(-2.5 -0.334)"
  }), U.createElement("path", {
    style: r.line,
    d: "M20.5,6.333V22.667A2.333,2.333,0,0,1,18.167,25H6.5a2.333,2.333,0,0,1-2.332-2.332V6.333m3.5,0V4A2.333,2.333,0,0,1,10,1.667h4.668A2.333,2.333,0,0,1,17,4V6.333",
    transform: "translate(-1.833 -1.667)"
  }), U.createElement("line", {
    style: r.line,
    y2: "7",
    transform: "translate(8.167 10.5)"
  }), U.createElement("line", {
    style: r.line,
    y2: "7",
    transform: "translate(12.833 10.5)"
  })));
},
    Ye = function Ye(e) {
  var t = e.styles,
      r = n(n({}, Te), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("g", {
    transform: "translate(1.166 3.5)"
  }, U.createElement("path", {
    style: r.line,
    d: "M18.333,19.5V17.166A4.666,4.666,0,0,0,13.667,12.5H5.5A4.667,4.667,0,0,0,.833,17.166V19.5",
    transform: "translate(-0.833 1.5)"
  }), U.createElement("circle", {
    style: r.line,
    cx: "4.667",
    cy: "4.667",
    r: "4.667",
    transform: "translate(4.084 0)"
  }), U.createElement("line", {
    style: r.line,
    y2: "7",
    transform: "translate(22.167 5.833)"
  }), U.createElement("line", {
    style: r.line,
    x1: "7",
    transform: "translate(18.667 9.333)"
  })));
},
    Ge = function Ge(e) {
  var t = e.styles,
      r = n(n({}, Te), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("g", {
    transform: "translate(2.334 2.192)"
  }, U.createElement("path", {
    style: r.line,
    d: "M12.167,3.333H4A2.334,2.334,0,0,0,1.667,5.667V22A2.333,2.333,0,0,0,4,24.333H20.333A2.334,2.334,0,0,0,22.667,22V13.833",
    transform: "translate(-1.667 -0.858)"
  }), U.createElement("path", {
    style: r.line,
    d: "M18.917,2.29a2.475,2.475,0,0,1,3.5,3.5L11.333,16.874,6.667,18.04l1.166-4.666Z",
    transform: "translate(0.333 -1.565)"
  })));
},
    Je = function Je(e) {
  var t = e.styles,
      r = n(n({}, De), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 33.5 33.5"
  }, U.createElement("g", {
    id: "cake",
    transform: "translate(-3.25 -3.25)"
  }, U.createElement("rect", {
    style: r.bg,
    transform: "translate(4 4)"
  }), U.createElement("path", {
    style: r.line,
    d: "M35.2,31.09H32.75V16.48a1.048,1.048,0,0,0-.2-.655A9.766,9.766,0,0,0,27.245,11.2a3.538,3.538,0,0,0-.9-1.77,2.416,2.416,0,0,1,1.225-.519.75.75,0,1,0-.107-1.5,4.241,4.241,0,0,0-2.41,1.131,3.515,3.515,0,0,0-4.814,2.985l-12.16,3.68a1.574,1.574,0,0,0-.954,1.034.77.77,0,0,0-.038.238V31.09H4.8a.75.75,0,0,0,0,1.5H35.2a.75.75,0,0,0,0-1.5Zm-12.972-20.6a2.088,2.088,0,0,1,.392-.353h0a2.025,2.025,0,0,1,.471-.226c.041-.015.083-.027.126-.039a1.839,1.839,0,0,1,1.035-.015c.04.01.079.024.118.037a2.032,2.032,0,0,1,.365.155c.024.014.05.026.074.04a2.028,2.028,0,0,1,.463,3.121l-.02.024a2.184,2.184,0,0,1-.173.16c-.035.03-.069.06-.106.088-.053.039-.107.074-.163.108s-.108.061-.164.089-.1.049-.153.069a2.154,2.154,0,0,1-.224.07c-.043.011-.085.025-.129.034a2.088,2.088,0,0,1-.382.038,2.015,2.015,0,0,1-.552-.085c-.041-.012-.081-.023-.121-.038a2.052,2.052,0,0,1-.484-.237l0,0a2.045,2.045,0,0,1-.4-.369c-.02-.024-.04-.047-.059-.072a2.005,2.005,0,0,1,.009-2.5C22.178,10.551,22.2,10.521,22.228,10.491Zm-1.8,2.546a3.53,3.53,0,0,0,6.741-.277,8.414,8.414,0,0,1,3.568,2.97H11.535ZM31.25,31.09H8.59V27.87H31.25Zm0-4.72H8.59V24.51H31.25Zm0-3.36H8.59V20.257a2.166,2.166,0,0,0,1.575.906,1.44,1.44,0,0,0,.217-.016c.847-.071,1.309-.807,1.681-1.4a5.588,5.588,0,0,1,.466-.684,2.946,2.946,0,0,1,.6.749c.415.63.94,1.405,1.816,1.332.831-.075,1.226-.807,1.543-1.4a4.125,4.125,0,0,1,.419-.685,2.792,2.792,0,0,1,.612.653,2.693,2.693,0,0,0,2.051,1.349h0a2.51,2.51,0,0,0,1.779-1.41c.132-.2.353-.542.367-.594a2.86,2.86,0,0,1,.558.736c.4.637.907,1.415,1.719,1.351.871,0,1.319-.8,1.646-1.391.132-.237.353-.634.391-.7a2.736,2.736,0,0,1,.509.7c.374.619.867,1.459,1.774,1.392.915,0,1.39-.831,1.771-1.5a4.567,4.567,0,0,1,.452-.695,6.985,6.985,0,0,1,.707,1.428Zm0-5.4a1.289,1.289,0,0,0-.69-.2c-.915,0-1.39.831-1.771,1.5a7.254,7.254,0,0,1-.465.755,2.833,2.833,0,0,1-.494-.68c-.38-.63-.852-1.413-1.75-1.413-.931,0-1.4.843-1.744,1.459a4.78,4.78,0,0,1-.361.584,4.693,4.693,0,0,1-.42-.607c-.4-.64-.9-1.436-1.8-1.436-.834,0-1.292.7-1.66,1.268-.177.269-.471.721-.58.732-.208,0-.575-.468-.817-.778-.452-.576-1.016-1.291-1.886-1.22-.895.075-1.329.879-1.646,1.466-.1.181-.251.465-.327.575a4.827,4.827,0,0,1-.461-.625c-.417-.632-.936-1.418-1.823-1.418s-1.382.766-1.768,1.382c-.144.229-.411.655-.578.7-.025-.006-.5.005-1.624-2.155V17.23H31.25Z"
  })));
},
    Xe = function Xe(e) {
  var t = e.styles,
      r = n(n({}, Ue), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 48 48"
  }, U.createElement("g", {
    transform: "translate(-200)"
  }, U.createElement("rect", {
    style: r.bg,
    transform: "translate(200)"
  }), U.createElement("g", {
    transform: "translate(207.807 6.032)"
  }, U.createElement("path", {
    d: "M237.953,7.521a.362.362,0,0,0-.078-.052A7.838,7.838,0,0,0,233.852,7a9.244,9.244,0,0,0-5.551-.122,7.1,7.1,0,0,0-5.153-.187.351.351,0,0,0-.26.117A.293.293,0,0,0,222.76,7a39.386,39.386,0,0,1-4.122,5.673,67.9,67.9,0,0,0-4.528,6.922,135.371,135.371,0,0,0-7.571,13.4.289.289,0,0,0,.176.411c.012.008.017.02.03.027a7.17,7.17,0,0,0,4.619.726c.018,0,.028-.011.044-.016a7.343,7.343,0,0,0,2.228.444c.727.03,1.454.022,2.182,0a24.611,24.611,0,0,0,3.2.13h.01a117.287,117.287,0,0,0,12.232-1.446c1.78-.3,3.6-.629,5.359-.993.728-.152.941-.184,1.214-.8.224-.5-.022-1.433-.006-1.968.028-.95.127-1.9.229-2.842.18-1.652.338-3.292.386-4.952.1-3.359.239-6.717.358-10.077C238.82,11.036,239.277,7.676,237.953,7.521ZM207.531,32.937a146.122,146.122,0,0,1,7.726-13.556,63.957,63.957,0,0,1,4.38-6.6,37.483,37.483,0,0,0,3.9-5.4,5.93,5.93,0,0,1,4.2.125q-.331.6-.712,1.182a2.317,2.317,0,0,0-2.692-.7,1.542,1.542,0,0,0-.85.492c-.5.612-.068,1.345-.647,2.028a6.881,6.881,0,0,1-1.363.894c-1.477,1-.558,2.4-1.74,3.568-.622.615-.817.572-1.13,1.376A1.608,1.608,0,0,1,218.3,17.7a6.75,6.75,0,0,1-1.1.656c-.164.132-.414.171-.547.339-.44.558-.161,1.329-.344,1.934-.455,1.489-1.621,1.2-2.375,2.242-.574.8-.071,1.719-.8,2.408-.569.535-1.513.678-2.014,1.3-.632.787-.2,1.736-.553,2.611s-1.459,1.312-1.638,2.226c-.233,1.187,1.361,1.511,2.521,1.56-.066.136-.136.271-.2.407a.327.327,0,0,0-.04.028.653.653,0,0,0-.078,0A6.367,6.367,0,0,1,207.531,32.937Zm4.29-.734c-.808.01-1.108.042-1.36-.682-.277-.8-.014-.629.5-1.125a2.2,2.2,0,0,0,.732-1.217c.263-1.178-.272-1.986,1.093-2.774a4.751,4.751,0,0,0,1.34-.873,3.031,3.031,0,0,0,.367-.806,2.378,2.378,0,0,0-.032-.611l1.637-1.571c.145-.125.439-.171.566-.325.8-.963.122-2.37.985-3.2.464-.446,1.19-.536,1.588-1.091.277-.388.154-.7.3-1.1.481-1.317,1.637-1.574,1.823-3.006.116-.895.091-1.342.924-1.972a8.468,8.468,0,0,0,1.507-1.081,1.647,1.647,0,0,0,.367-.946c.106-.522-.1-.8.415-1.089a1.375,1.375,0,0,1,1.891.7c.006.015.018.023.025.036-.866,1.2-1.842,2.355-2.764,3.518a76.37,76.37,0,0,0-4.586,6.959C216.587,23.992,213.946,27.978,211.821,32.2Zm1.994,1.613a8.291,8.291,0,0,1-1.171-.072,2.736,2.736,0,0,1-.53-.163c2.284-4.82,5.329-9.289,8.188-13.86a70.993,70.993,0,0,1,4.423-6.623,36.285,36.285,0,0,0,3.96-5.5c0-.007,0-.013.006-.021a8.651,8.651,0,0,1,4.486.021c-.292.522-.614,1.031-.96,1.529a2.3,2.3,0,0,0-2.906-.8c-.433.234-.4.385-.59.835-.312.752-.266,1.231-1.022,1.792-.349.258-.814.43-1.133.718a1.338,1.338,0,0,0-.541,1.016c-.119.55.11,1.288-.21,1.8-.242.383-.838.5-1.145.8-.786.772-.226,1.612-.884,2.418-.488.595-1.384.616-1.776,1.263-.764,1.26.338,1.82-1.3,3.056-.721.546-1.364.59-1.607,1.549-.079.312.078.734-.013,1.014-.241.728-.8.856-1.451,1.253a2.915,2.915,0,0,0-1.3,1.143,3.729,3.729,0,0,0-.078,1.253,2.4,2.4,0,0,1-1.4,2.026,2.266,2.266,0,0,0-1.2,1.313c-.3,1.326.936,1.711,2.143,1.685-.095.188-.193.374-.284.564C214.958,33.829,214.385,33.837,213.815,33.816Zm2.4-1.356c-.016,0-.026-.005-.042,0-.79.069-.634.182-.752-.745-.127-1-.06-.752.655-1.213a2.559,2.559,0,0,0,.983-.9c.354-.708-.04-1.48.277-2.212.374-.867,1.1-.92,1.848-1.5a2.028,2.028,0,0,0,.715-.78c.078-.181.028-.36.09-.535a4.786,4.786,0,0,1,1.651-2.052c1.063-.9.848-1.27,1.084-2.525.229-1.225,1.7-1.447,2.278-2.585.216-.425.055-.684.349-1.18.358-.6.557-.453.888-.9a2.529,2.529,0,0,0,.534-1.012c.126-.5-.066-1.187.15-1.646.338-.719,1.248-1,1.867-1.5a2.4,2.4,0,0,0,.8-.893c.1-.222-.041-.459.034-.671L229.749,9a1.582,1.582,0,0,1,1.918.883v0c-.856,1.149-1.794,2.258-2.678,3.379-1.781,2.258-3.124,4.726-4.74,7.071C221.484,24.349,218.472,28.219,216.213,32.461Zm.269,1.387c2.38-4.855,5.868-9.175,8.946-13.707,1.466-2.16,2.7-4.41,4.336-6.483a42.665,42.665,0,0,0,4.316-5.9,7.227,7.227,0,0,1,2.791.19,21.615,21.615,0,0,0-2.146,2.858q-1.9,2.415-3.75,4.862-3.463,4.587-6.73,9.283c-2.021,2.9-4.286,5.791-5.548,9.023A12.337,12.337,0,0,1,216.482,33.847ZM237.912,11.3q-.04,1.155-.085,2.31c-.1,2.582-.209,5.162-.275,7.745-.073,2.851-.592,5.675-.63,8.524-.012.917.292,1.217-.918,1.684a11.769,11.769,0,0,1-1.627.3c-1.522.318-3.034.615-4.573.861q-5.029.807-10.122,1.168a41.658,41.658,0,0,1,4.471-7.292q2.592-3.767,5.31-7.467t5.562-7.328q.709-.908,1.429-1.809c.452-.569.79-1.635,1.506-.761C238.246,9.58,237.929,10.817,237.912,11.3Z",
    transform: "translate(-206.506 1.25)"
  }), U.createElement("path", {
    style: r.line,
    d: "M11387.679,1785.81a3.761,3.761,0,0,0-1.3.086,1.331,1.331,0,0,0-1.106,1.311,2,2,0,0,0,1.43,2.087,2.913,2.913,0,0,0,2.094.087,1.6,1.6,0,0,0,.979-1.665c-.135-.93-.312-1.188-.863-1.5A3.878,3.878,0,0,0,11387.679,1785.81Z",
    transform: "translate(-11362.754 -1781.988)"
  }), U.createElement("path", {
    style: r.line,
    d: "M11393.478,1742.776a5.37,5.37,0,0,0,.438,2.108c.433.785.965,1.7.965,1.7",
    transform: "translate(-11370.123 -1742.776)"
  }))));
},
    Ke = function Ke(e) {
  var t = e.styles,
      r = n(n({}, De), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 33.5 33.5"
  }, U.createElement("g", {
    id: "brunch",
    transform: "translate(0.75 0.75)"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M16,.25A15.75,15.75,0,1,0,31.75,16,15.767,15.767,0,0,0,16,.25Zm0,30A14.25,14.25,0,1,1,30.25,16,14.267,14.267,0,0,1,16,30.25Zm2-17a3.55,3.55,0,1,0,3.55,3.55A3.553,3.553,0,0,0,18,13.25Zm0,5.6a2.05,2.05,0,1,1,2.05-2.05A2.053,2.053,0,0,1,18,18.85Zm7.629-5.982a.778.778,0,0,0-.144-.111,6.4,6.4,0,0,0-2.916-.848c-.819-.08-1.128-.137-1.363-.45-.217-.3-.182-.6-.1-1.144a3.068,3.068,0,0,0-.261-2.193v0a3.729,3.729,0,0,0-2.089-1.54,4.014,4.014,0,0,0-.266-.969.757.757,0,0,0-.315-.36l-4.3-2.5a.751.751,0,0,0-1.127.678,6,6,0,0,1-.828,3.829,2.718,2.718,0,0,1-.277.338,2.976,2.976,0,0,1-1.16.748c-.051.022-.1.048-.157.071A3.718,3.718,0,0,0,8.7,9.65,3.86,3.86,0,0,0,7.916,12.1c0,.065,0,.13,0,.193a2.945,2.945,0,0,1-.43,1.779,3.213,3.213,0,0,1-.243.3A4.638,4.638,0,0,1,6,15.325,5.091,5.091,0,0,0,3.941,17.24,6.494,6.494,0,0,0,3.25,20.5c0,.689,1.633,1.463,2.472,1.79a14.038,14.038,0,0,0,2.143,1.181.759.759,0,0,0,.335.079.749.749,0,0,0,.4-.112.738.738,0,0,0,.282-.356,7.431,7.431,0,0,0,5.22,2.632,4.769,4.769,0,0,0,.826-.074,3.688,3.688,0,0,0,2.251-1.331,4.141,4.141,0,0,1,1.709-1.214,4.991,4.991,0,0,1,2.977-.2,5.112,5.112,0,0,0,3.376-.326,5.683,5.683,0,0,0,3.113-5.2A5.773,5.773,0,0,0,25.629,12.868ZM6.157,18.614a4.838,4.838,0,0,0-.647,1.912c-.277-.148-.557-.3-.757-.417a4.608,4.608,0,0,1,.494-2.13,3.626,3.626,0,0,1,1.518-1.363l.183-.111A5.333,5.333,0,0,0,8.639,15.02c.03-.041.061-.07.091-.113A4.349,4.349,0,0,0,9.41,12.4l0-.077A2.575,2.575,0,0,1,9.9,10.55a2.467,2.467,0,0,1,1.183-.83l.09-.041A4.206,4.206,0,0,0,12.73,8.63c.058-.057.117-.125.176-.192a5.106,5.106,0,0,0,1.017-1.956,8.4,8.4,0,0,0,.309-1.789l.542.315c.031.466.034.894.022,1.3a7.971,7.971,0,0,1-.181,1.557,2.958,2.958,0,0,1-.945,1.72,3.084,3.084,0,0,1-1.011.423,3.627,3.627,0,0,0-1.912,1.085,3.236,3.236,0,0,0-.826,2.348,3.543,3.543,0,0,1-.392,1.724,3.031,3.031,0,0,1-1.07,1.19c-.1.075-.212.149-.328.227a6.967,6.967,0,0,0-1.231,1A4.541,4.541,0,0,0,6.157,18.614ZM8.518,19c-.034.047-.071.08-.1.131a4.248,4.248,0,0,0-.837,1.9c-.037.19-.065.379-.083.563-.211-.111-.394-.211-.538-.291a4.247,4.247,0,0,1,.236-1.375,4.007,4.007,0,0,1,1.231-1.71c.175-.136.354-.264.546-.393A4.9,4.9,0,0,0,11.42,13.5a1.826,1.826,0,0,1,.437-1.4,2.187,2.187,0,0,1,1.212-.651,4.512,4.512,0,0,0,1.492-.659,4.722,4.722,0,0,0,1.6-3.086A10.361,10.361,0,0,0,16.3,6.2c0-.1.009-.2.008-.3l.548.318.336.2a2.887,2.887,0,0,1,.07,1.359,5.292,5.292,0,0,1-1.29,2.515.753.753,0,0,0-.12.1,3.12,3.12,0,0,1-1.279.853A3.794,3.794,0,0,0,12.8,12.55a4.4,4.4,0,0,0-.848,2.579,2.676,2.676,0,0,1-.546,1.713,2.733,2.733,0,0,1-1.2.861A3.858,3.858,0,0,0,8.518,19Zm16.047,2.229a3.655,3.655,0,0,1-2.473.186,6.392,6.392,0,0,0-3.759.284,5.59,5.59,0,0,0-2.248,1.578,2.229,2.229,0,0,1-1.419.885c-1.879.341-4.086-1.1-5.152-2.691a6.045,6.045,0,0,1-.348-.57,2.8,2.8,0,0,1,.465-.9,2.374,2.374,0,0,1,1.208-.941,4.174,4.174,0,0,0,1.746-1.3,4.056,4.056,0,0,0,.863-2.531,2.921,2.921,0,0,1,.546-1.78,2.355,2.355,0,0,1,1.157-.832,4.579,4.579,0,0,0,1.786-1.2A6.611,6.611,0,0,0,18.7,8.168a1.929,1.929,0,0,1,.855.711,1.685,1.685,0,0,1,.075,1.2A2.76,2.76,0,0,0,20,12.35,3.016,3.016,0,0,0,22.423,13.4a5.035,5.035,0,0,1,2.256.62c.02.016.043.033.068.051a4.374,4.374,0,0,1,2.1,3.367A4.148,4.148,0,0,1,24.565,21.229Z"
  })));
},
    Qe = function Qe(e) {
  var t = e.styles,
      r = n(n({}, Fe), t);
  return U.createElement("svg", {
    viewBox: "0 0 48 48"
  }, U.createElement("g", {
    id: "brunch-icon-2",
    transform: "translate(-50)"
  }, U.createElement("rect", {
    style: r.bg,
    transform: "translate(50)"
  }), U.createElement("g", {
    transform: "translate(53.6 5.167)"
  }, U.createElement("path", {
    style: r.line,
    d: "M93.37,12.485a9.9,9.9,0,0,0-4.156-5.9c-2.461-1.51-2.662-1.513-5.116-1.562l-.6-.012c-3.631-.084-5.029-.2-6.648-.324C75.514,4.583,74,4.462,70.9,4.342a.363.363,0,0,0-.076.006c-.433-.028-.869-.042-1.3-.042a22.276,22.276,0,0,0-9.233,2.035,12.285,12.285,0,0,0-7.12,8.536,7.9,7.9,0,0,0,.617,5.075,11.309,11.309,0,0,0,.554,1.031,7.058,7.058,0,0,1,.762,1.59,9.1,9.1,0,0,1,.238,1.7c.02.262.041.52.07.767.248,2.134.4,4.432.451,7.025.01.467.01.948.011,1.436a20.189,20.189,0,0,0,.526,5.616c.458,1.541,1.631,2.387,3.69,2.663a22.827,22.827,0,0,0,3.044.173c.856,0,1.717-.029,2.563-.056.529-.017,1.054-.034,1.568-.044,1.7-.035,3.4-.037,5.094-.041l1.27,0c.42,0,.848.008,1.278.017s.883.019,1.327.019l.175,0a.645.645,0,0,0,.179.023h0c.49-.011.966-.014,1.432-.014,1.3,0,2.522.034,3.668.066,1.021.03,1.985.058,2.9.058h0c.432,0,.853-.007,1.267-.022,3.025-.107,4.728-.8,5.645-4.322a26.543,26.543,0,0,0,.221-6.959l-.011-.206c-.085-1.544-.166-3.2-.194-4.824a10.559,10.559,0,0,1,.894-4.086l.128-.352C93.536,18.46,94.321,15.508,93.37,12.485ZM79.208,40.32a10.179,10.179,0,0,1-2.8.308c-.484,0-.967-.016-1.444-.03s-.917-.029-1.356-.029H72.374c-1.7,0-3.409.006-5.112.043-.378.007-.756.01-1.134.01-.6,0-1.211-.007-1.816-.014S63.1,40.6,62.5,40.6l-.974,0a7.835,7.835,0,0,1-2.266-.256c-1.535-.456-1.774-1.709-1.9-3.061-.157-1.718-.205-3.469-.251-5.164-.049-1.8-.1-3.654-.287-5.539-.125-1.254-.253-2.55-.45-3.811a6.951,6.951,0,0,0-.924-2.287c-.2-.366-.408-.744-.581-1.139C53.1,15.3,55.489,11.35,58.312,9,61.386,6.436,66.1,5.524,69.484,5.524c.163,0,.323,0,.482,0a27.99,27.99,0,0,1,5.8.937A13.185,13.185,0,0,1,81.324,8.8a8.74,8.74,0,0,1,1.94,11.341l-.27.474A10.948,10.948,0,0,0,81.535,24a19.479,19.479,0,0,0-.229,3.72c0,.528,0,1.052-.017,1.566l-.07,1.943c-.038,1.03-.078,2.06-.106,3.091-.007.27-.006.572,0,.894C81.121,37.138,81.138,39.778,79.208,40.32ZM91.794,19.494l-.11.361a14.279,14.279,0,0,1-.552,1.438A12.405,12.405,0,0,0,90.5,23a11.612,11.612,0,0,0-.19,3.422l.013.314c.024.6.055,1.2.086,1.8.065,1.236.132,2.514.134,3.769,0,.244.006.512.011.8.029,1.572.068,3.724-.583,4.962a4.368,4.368,0,0,1-3.8,2.335,23.163,23.163,0,0,1-2.843.2c-.3,0-.581-.008-.886-.017-.365-.008-.762-.02-1.264-.02h-.068c1.378-1.526,1.334-4.334,1.3-6.6-.008-.557-.016-1.073,0-1.516l.055-1.52c.046-1.217.09-2.432.12-3.649l.011-.529a10.855,10.855,0,0,1,.469-3.6,10.97,10.97,0,0,1,.928-1.813c.191-.322.383-.643.557-.979a9.831,9.831,0,0,0-.678-10.674A12.278,12.278,0,0,0,78.318,5.87c.708.031,1.348.065,1.945.1,1.208.065,2.252.12,3.352.12.172,0,.685-.006.685-.006,2.945,0,5.3,1.544,7,4.592a10.4,10.4,0,0,1,1.32,4.334A13.079,13.079,0,0,1,91.794,19.494Z",
    transform: "translate(-53 -4.306)"
  }), U.createElement("path", {
    style: r.line,
    d: "M82.182,17.433c.91-2.9,0-6.716-2.548-8.575-2.743-2-7.345-2.795-10.678-2.832A17.456,17.456,0,0,0,58.095,9.619c-2.621,2.176-4.127,6.438-2.491,9.631,2.442,3.612,1.811,7.65,2.012,11.814.094,1.936-.32,5.437.7,7.174a2.636,2.636,0,0,0,2.323.985c2.849.167,5.807-.067,8.669-.032,2.573.031,8.2,1.262,9.808-1.57.95-1.672.36-4.267.314-6.08-.054-2.155-.054-4.309.052-6.462C79.624,22.171,81.336,20.133,82.182,17.433Zm-3.907,9.818c-.041,2.062.016,4.122.083,6.182.054,1.678.592,3.822-1.576,4.566a12.9,12.9,0,0,1-3.856.1c-2.6-.018-5.195-.071-7.792-.088-1.308-.008-2.714.18-4.012.067-2.477-.214-1.552,0-1.939-1.2-.822-2.545-.487-6.065-.547-8.722-.035-1.594.121-3.2-.023-4.79a9.515,9.515,0,0,0-2.035-4.682c-2.81-5.492,3.456-9.512,7.775-10.841,3.941-1.213,8.088-.584,11.948.708,3.175,1.063,5.444,3.683,5.12,7.25a11.1,11.1,0,0,1-1.382,3.743A15.717,15.717,0,0,0,78.275,27.252Z",
    transform: "translate(-52.615 -3.962)"
  }), U.createElement("path", {
    style: r.line,
    d: "M59.513,13.953a.566.566,0,0,0,0,1.13A.566.566,0,0,0,59.513,13.953Z",
    transform: "translate(-51.806 -2.377)"
  }), U.createElement("path", {
    style: r.line,
    d: "M62.2,10.944a.566.566,0,0,0,0,1.13A.566.566,0,0,0,62.2,10.944Z",
    transform: "translate(-51.269 -2.978)"
  }), U.createElement("path", {
    style: r.line,
    d: "M64.565,14.114a.566.566,0,0,0,0,1.13A.566.566,0,0,0,64.565,14.114Z",
    transform: "translate(-50.796 -2.344)"
  }), U.createElement("path", {
    style: r.line,
    d: "M67.575,10.621a.566.566,0,0,0,0,1.13A.566.566,0,0,0,67.575,10.621Z",
    transform: "translate(-50.194 -3.043)"
  }), U.createElement("path", {
    style: r.line,
    d: "M70.7,14.061h-.065a.566.566,0,0,0,0,1.13H70.7A.566.566,0,0,0,70.7,14.061Z",
    transform: "translate(-49.581 -2.355)"
  }), U.createElement("path", {
    style: r.line,
    d: "M73.433,11.533a.566.566,0,0,0,0,1.13A.566.566,0,0,0,73.433,11.533Z",
    transform: "translate(-49.023 -2.861)"
  }), U.createElement("path", {
    style: r.line,
    d: "M61.232,19.41a.566.566,0,0,0,0,1.13A.566.566,0,0,0,61.232,19.41Z",
    transform: "translate(-51.463 -1.285)"
  }), U.createElement("path", {
    style: r.line,
    d: "M67.008,18.575a.566.566,0,0,0,0,1.13A.566.566,0,0,0,67.008,18.575Z",
    transform: "translate(-50.307 -1.452)"
  }), U.createElement("path", {
    style: r.line,
    d: "M71.928,18.844a.566.566,0,0,0,0,1.13A.566.566,0,0,0,71.928,18.844Z",
    transform: "translate(-49.323 -1.398)"
  }), U.createElement("path", {
    style: r.line,
    d: "M63.923,23a.566.566,0,0,0,0,1.13A.566.566,0,0,0,63.923,23Z",
    transform: "translate(-50.924 -0.568)"
  }), U.createElement("path", {
    style: r.line,
    d: "M70.1,23.681a.566.566,0,0,0,0,1.13A.566.566,0,0,0,70.1,23.681Z",
    transform: "translate(-49.689 -0.431)"
  }), U.createElement("path", {
    style: r.line,
    d: "M60.749,27.073a.566.566,0,0,0,0,1.13A.566.566,0,0,0,60.749,27.073Z",
    transform: "translate(-51.559 0.247)"
  }), U.createElement("path", {
    style: r.line,
    d: "M66.177,27.227a.566.566,0,0,0,0,1.132A.566.566,0,0,0,66.177,27.227Z",
    transform: "translate(-50.474 0.278)"
  }), U.createElement("path", {
    style: r.line,
    d: "M72.143,27.657a.566.566,0,0,0,0,1.13A.566.566,0,0,0,72.143,27.657Z",
    transform: "translate(-49.28 0.364)"
  }), U.createElement("path", {
    style: r.line,
    d: "M62.835,30.833l-.064.065a.565.565,0,0,0,.8.8l.064-.065A.565.565,0,0,0,62.835,30.833Z",
    transform: "translate(-51.079 0.966)"
  }), U.createElement("path", {
    style: r.line,
    d: "M69.144,30.452h-.065a.566.566,0,0,0,0,1.13h.065A.566.566,0,0,0,69.144,30.452Z",
    transform: "translate(-49.893 0.923)"
  }))));
},
    et = function et(e) {
  var t = e.styles,
      r = n(n({}, Te), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 20 20"
  }, U.createElement("rect", {
    id: "Area",
    width: "20",
    height: "20",
    fill: "#fcfcfc",
    opacity: "0"
  }), U.createElement("g", {
    transform: "translate(1.29 2.499)"
  }, U.createElement("path", {
    style: r.line,
    d: "M5,7.5V1.667H15V7.5",
    transform: "translate(-1.29 -2.499)"
  }), U.createElement("path", {
    style: r.line,
    d: "M5,15H3.333a1.666,1.666,0,0,1-1.666-1.667V9.167A1.666,1.666,0,0,1,3.333,7.5H16.667a1.666,1.666,0,0,1,1.666,1.667v4.166A1.666,1.666,0,0,1,16.667,15H15",
    transform: "translate(-1.29 -2.499)"
  }), U.createElement("rect", {
    style: r.line,
    width: "10",
    height: "6.667",
    transform: "translate(3.71 9.168)"
  })));
},
    tt = function tt(e) {
  var t = e.styles,
      r = e.color,
      a = void 0 === r ? "#3e3e3e" : r,
      l = n(n({}, De), t);
  return U.createElement("svg", {
    style: l.svg,
    viewBox: "0 0 33 33"
  }, U.createElement("defs", null, U.createElement("clipPath", {
    id: "clip-path"
  }, U.createElement("path", {
    d: "M13.255,0H0V13.253H6.652v-5.8h6.6Z",
    style: l.line,
    "stroke-width": "1"
  }))), U.createElement("g", {
    id: "drinks",
    transform: "translate(0.5 0.5)"
  }, U.createElement("rect", {
    width: "32",
    height: "32",
    style: l.line,
    "stroke-width": "1",
    opacity: "0"
  }), U.createElement("g", {
    id: "Rectangle_699",
    "data-name": "Rectangle 699",
    transform: "translate(6.652 6.652)",
    fill: "none",
    stroke: a,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1.5"
  }, U.createElement("path", {
    d: "M1.893,0H20.809A1.893,1.893,0,0,1,22.7,1.893V16.725a8.624,8.624,0,0,1-8.624,8.624H8.624A8.624,8.624,0,0,1,0,16.725V1.893A1.893,1.893,0,0,1,1.893,0Z",
    stroke: "none"
  }), U.createElement("path", {
    d: "M1.893.75H20.809a1.143,1.143,0,0,1,1.143,1.143V16.725A7.874,7.874,0,0,1,14.078,24.6H8.624A7.874,7.874,0,0,1,.75,16.725V1.893A1.143,1.143,0,0,1,1.893.75Z",
    fill: "none"
  })), U.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M9.208,21.906a8.18,8.18,0,0,1,4.525-1.743c2.873-.11,3.5,1.725,6.226,1.651,3.027-.082,3.839-2.394,6.574-2.064a6.559,6.559,0,0,1,3.83,2.156",
    transform: "translate(-1.842 -3.944)",
    fill: "none",
    stroke: a,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1.5"
  }), U.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M30,25.24v-22a.785.785,0,0,1,.769-.8H35.6",
    transform: "translate(-6 -0.488)",
    fill: "none",
    stroke: a,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1.5"
  }), U.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71"
  }, U.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    "clip-path": "url(#clip-path)"
  }, U.createElement("g", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    transform: "translate(0 0)",
    fill: "none",
    stroke: a,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1.5"
  }, U.createElement("circle", {
    cx: "6.652",
    cy: "6.652",
    r: "6.652",
    stroke: "none"
  }), U.createElement("circle", {
    cx: "6.652",
    cy: "6.652",
    r: "5.902",
    fill: "none"
  }))))));
},
    rt = function rt(e) {
  var t = e.styles,
      r = n(n({}, Fe), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 48 48"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("g", {
    id: "Group_4719",
    "data-name": "Group 4719",
    transform: "translate(2.4 7.766)"
  }, U.createElement("path", {
    d: "M44.99,13.574a.551.551,0,0,0-.062-.211C44.552,10.752,42.379,8.768,40,7.8c-4.249-1.73-9.342-1.469-13.79-.882a56.36,56.36,0,0,0-13.2,3.134C6.782,12.5.793,18.54,2.21,25.4a.493.493,0,0,0-.017.115c.251,4.753,1.1,10.025,6,12.124,5.348,2.288,10.586,1.308,15.732-1.04A23.97,23.97,0,0,0,30.9,32.051c2.27-2.276,3.72-5.24,6.086-7.458,1.714-1.607,3.46-2.164,5.491-3.193a4.61,4.61,0,0,0,1.559-1.081C45.63,18.5,45.189,15.768,44.99,13.574ZM6.656,15.2c3-3.1,7.307-4.613,11.393-5.65a54.786,54.786,0,0,1,14.225-2,21.074,21.074,0,0,1,7.069,1.082c2.1.8,4.337,2.7,4.616,4.988h0a4.072,4.072,0,0,1-.454,2.388c-1.512,2.948-5.822,3.662-8.322,5.551-3.076,2.323-5.2,5.628-8.022,8.216-7.013,6.43-19.038,8.328-23.12-2.18a.59.59,0,0,0-.034-.054C4,27.527,4,27.506,3.99,27.482,1.96,23.264,3.532,18.436,6.656,15.2Zm34.981,5.429c-1.945,1.031-3.752,1.667-5.383,3.227a38.045,38.045,0,0,0-4.117,4.988,20.474,20.474,0,0,1-6.313,5.605c-4.2,2.5-9.63,4.354-14.5,3.138-3.158-.79-5.468-2.129-6.821-5.184a13.148,13.148,0,0,1-.972-3.359,11.25,11.25,0,0,0,5.957,6.2,15.263,15.263,0,0,0,10.712.047c8.2-2.88,11.8-11.335,19.4-15.041A11.6,11.6,0,0,0,44.07,17.02,4.272,4.272,0,0,1,41.637,20.633Z",
    transform: "translate(-2 -6.472)",
    style: r.line
  }), U.createElement("path", {
    d: "M4.695,24.227a.511.511,0,0,0,0,.074c1.237,6.395,7.258,8.3,13.165,7.183,3.271-.618,5.885-2.771,8.141-5.106a57.289,57.289,0,0,1,9.347-8.386c1.738-1.157,4.364-2.219,4.376-4.753A4.544,4.544,0,0,0,37.413,9.9c-2.06-1.066-5.039-.947-7.294-.868a47.042,47.042,0,0,0-9.8,1.62c-6.876,1.712-16.54,4.436-15.643,13.508A.62.62,0,0,0,4.695,24.227ZM23.022,11.07c3.053-.719,14.647-3.143,15.412,1.945.33,2.189-1.847,2.96-3.356,3.922-1.243.793-2.407,1.732-3.587,2.615-2.592,1.943-4.566,4.476-6.854,6.739a14.028,14.028,0,0,1-9.884,4.493c-4.574.162-8.152-2.226-9.046-6.7C4.846,14.693,16.172,12.685,23.022,11.07Z",
    transform: "translate(-1.476 -5.969)",
    style: r.line
  }), U.createElement("path", {
    d: "M12.611,22.661a5.167,5.167,0,0,0,5.072-2.454,2.494,2.494,0,0,0-.191-2.608,2.932,2.932,0,0,0-2.083-.869.293.293,0,0,0-.065,0,.5.5,0,0,0-.072-.022c-1.825-.162-4.82.713-5.492,2.641C9.132,21.215,10.973,22.463,12.611,22.661Zm-.545-4.184a5.58,5.58,0,0,1,3.206-.728h.01a2.878,2.878,0,0,1,.949.185c1.282.676.457,2.074-.229,2.71a4.265,4.265,0,0,1-2.99,1.019C11.115,21.58,9.675,19.928,12.066,18.476Z",
    transform: "translate(-0.47 -4.428)",
    style: r.line
  }), U.createElement("path", {
    d: "M23.249,12.7a.518.518,0,0,0,0-1.036A.518.518,0,0,0,23.249,12.7Z",
    transform: "translate(2.15 -5.434)",
    style: r.line
  }), U.createElement("path", {
    d: "M24.776,12.184c1.818-.5,3.724-.92,5.422.155.565.359,1.085-.538.523-.894-1.933-1.226-4.133-.836-6.221-.26A.519.519,0,0,0,24.776,12.184Z",
    transform: "translate(2.427 -5.639)",
    style: r.line
  })));
},
    nt = function nt(e) {
  var t = e.styles,
      r = n(n({}, Fe), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 36.001 36"
  }, U.createElement("g", {
    transform: "translate(-4 -4)"
  }, U.createElement("rect", {
    style: r.bg,
    transform: "translate(4 4)"
  }), U.createElement("g", {
    transform: "translate(4 5.5)"
  }, U.createElement("path", {
    d: "M39.993,23.457c.2-3.481-3.71-5.582-4.995-6.272l-.228-.123A11.72,11.72,0,0,0,30.818,15.9l.912-.635a4.212,4.212,0,0,0,1.793-2.745,3.013,3.013,0,0,0-.494-2.3,2.842,2.842,0,0,0-1.958-1.2,3.959,3.959,0,0,0-2.932.761A3.8,3.8,0,0,0,28.258,8a2.909,2.909,0,0,0-1.286-1.964,3.011,3.011,0,0,0-2.307-.473A4.061,4.061,0,0,0,22.1,7.351l-8.4,13.136c-3.369.68-5.741,2.59-5.741,4.9,0,.034.008.068.008.1L5.148,27.7a2.622,2.622,0,0,0-.7,3.61,2.346,2.346,0,0,0,1.8.929,2.917,2.917,0,0,0-.185,1.74,2.258,2.258,0,0,0,2.189,1.8,2.513,2.513,0,0,0,.631-.084c1.387,1.676,4.213,2.8,7.554,2.8,3.816,0,6.882-1.391,8-3.427a3.444,3.444,0,0,0,.505.056,2.7,2.7,0,0,0,1.07-.213,3.631,3.631,0,0,0,.815-.514c.228-.179.319-.226.4-.228a1.2,1.2,0,0,1,.187.159,2.07,2.07,0,0,0,1.235.646,2.2,2.2,0,0,0,1.565-.475.968.968,0,0,1,.649-.245,1.11,1.11,0,0,1,.768.275,2.114,2.114,0,0,0,1.684.428,1.952,1.952,0,0,0,1.308-1.129,1.645,1.645,0,0,1,.592-.706,2,2,0,0,1,1.069-.3,1.738,1.738,0,0,0,1.757-2.41.947.947,0,0,1,0-.743c.07-.173.192-.257.5-.438A2.239,2.239,0,0,0,39.7,27.941a2.874,2.874,0,0,0-.45-2.153A5.077,5.077,0,0,0,39.993,23.457ZM33.935,20.7a6.556,6.556,0,0,0,.207-2.057l.062.033c.245.132.608.328,1.016.579a13.461,13.461,0,0,1-.3,2.066,1.036,1.036,0,0,1-.415.726.8.8,0,0,1-.667-.133C33.783,21.89,33.628,21.728,33.935,20.7Zm-5.1-3.192a21.265,21.265,0,0,1,.591,2.843.963.963,0,0,1-.114.728.9.9,0,0,1-.673.137c-.3-.031-.319-.958-.319-1.144a6.362,6.362,0,0,0-.487-2.1c-.048-.126-.1-.255-.146-.376.245-.03.512-.044.774-.061C28.59,17.529,28.706,17.513,28.838,17.507Zm.24-6.329a2.343,2.343,0,0,1,1.425-.511,1.919,1.919,0,0,1,.3.024,1.205,1.205,0,0,1,.849.51,1.362,1.362,0,0,1,.206,1.046,2.547,2.547,0,0,1-1.087,1.627l-2.879,2a20.631,20.631,0,0,0-2.823.481,18.6,18.6,0,0,0-4.707,1.615Zm-8.993,8.866a9.37,9.37,0,0,1,.664.8l-.073.051a11.366,11.366,0,0,0-1.356-.374C19.572,20.357,19.825,20.2,20.084,20.044Zm4.162,2.113a.83.83,0,0,1-.531.32c-.091.013-.406.047-.726-1.025-.008-.028-.025-.058-.035-.086a5.653,5.653,0,0,0-.821-1.485c-.165-.225-.336-.444-.506-.642.359-.164.722-.313,1.09-.451.079.116.186.28.308.473.251.395.564.922.846,1.468.108.211.215.423.307.632A1.058,1.058,0,0,1,24.247,22.157ZM23.513,8.278a2.4,2.4,0,0,1,1.468-1.058,1.442,1.442,0,0,1,.278-.028,1.365,1.365,0,0,1,.792.255,1.259,1.259,0,0,1,.554.865,2.471,2.471,0,0,1-.515,1.875l-1.956,2.708-7.121,5.553Zm-8.27,13.69c.15-.015.3-.03.452-.039.242-.014.49-.02.742-.02.327,0,.641.016.951.038a11.875,11.875,0,0,1,1.484.2,9.145,9.145,0,0,1,2.032.644c1.466.679,2.323,1.658,2.323,2.6,0,1.682-2.728,3.482-6.789,3.482a12.878,12.878,0,0,1-1.692-.114,10.631,10.631,0,0,1-1.8-.394l-.045-.016a7.287,7.287,0,0,1-1.773-.824,3.57,3.57,0,0,1-1.285-1.352,1.8,1.8,0,0,1-.2-.783C9.649,23.881,11.854,22.28,15.243,21.968ZM5.8,30.294a.986.986,0,0,1,.381-1.26l1.784-1.392v2.086l-.808.561C6.648,30.647,6.064,30.651,5.8,30.294Zm2.107,3.669a.539.539,0,0,1-.2-.34A1.245,1.245,0,0,1,7.9,32.7l.066-.1v.729a3.324,3.324,0,0,0,.08.686A.574.574,0,0,1,7.907,33.963Zm15.32-4.214v3.578A2,2,0,0,1,22.8,34.5c-.965,1.328-3.488,2.305-6.365,2.305a8.648,8.648,0,0,1-6.1-2.029,2.18,2.18,0,0,1-.692-1.453V28.514l.03.024a7.648,7.648,0,0,0,1.57.965c.216.1.442.2.675.284a11.413,11.413,0,0,0,1.721.495,13.748,13.748,0,0,0,2.792.283,11.957,11.957,0,0,0,5.69-1.318,7.232,7.232,0,0,0,1.1-.734ZM37.7,27.776a2.478,2.478,0,0,0-1.183,1.205,2.518,2.518,0,0,0-.1,1.834c.028.117.077.307.119.275a2.131,2.131,0,0,1-.377.05,3.612,3.612,0,0,0-1.851.571,3.262,3.262,0,0,0-1.147,1.305,1.618,1.618,0,0,1-.183.291c-.079.017-.115.009-.413-.187a2.6,2.6,0,0,0-1.756-.551,2.546,2.546,0,0,0-1.53.535c-.267.181-.316.2-.43.193-.062-.008-.1-.036-.268-.195a1.886,1.886,0,0,0-1.363-.624,2.208,2.208,0,0,0-1.414.585,2.022,2.022,0,0,1-.443.295,1.075,1.075,0,0,1-.451.068c0-.035.008-.068.008-.1V28.1a6.039,6.039,0,0,1,3.737-1.6,6.318,6.318,0,0,1,3.106,1,5.416,5.416,0,0,0,4.092.875,5.287,5.287,0,0,0,2.213-1.171.6.6,0,0,1,.027.262C38.056,27.554,37.972,27.615,37.7,27.776Zm-2.243-1.042a3.946,3.946,0,0,1-2.913-.726,7.881,7.881,0,0,0-3.894-1.19,6.949,6.949,0,0,0-3.737,1.213v-.368h-.021c.008-.091.021-.18.021-.271a3.425,3.425,0,0,0-.327-1.439,2.279,2.279,0,0,0,1.134-.975,2.59,2.59,0,0,0,.021-2.252c-.143-.327-.306-.65-.474-.965-.3-.559-.608-1.074-.854-1.462l-.027-.043c.044-.011.09-.02.135-.032.3-.077.6-.152.9-.213.162-.038.354-.08.549-.122a9.13,9.13,0,0,1,.432,1.08,3.988,3.988,0,0,1,.236,1.1c0,2.3,1.149,2.756,1.834,2.825q.174.017.338.017a2.328,2.328,0,0,0,1.7-.65,2.454,2.454,0,0,0,.585-2.111,20.854,20.854,0,0,0-.5-2.574,10.283,10.283,0,0,1,1.818.369,6.757,6.757,0,0,1-.085,2.242c-.188.633-.765,2.56.757,3.236a2.586,2.586,0,0,0,1.254.343,2.056,2.056,0,0,0,.845-.175,2.519,2.519,0,0,0,1.374-1.886c.1-.445.178-.885.233-1.295a3.841,3.841,0,0,1,1.519,2.954A3.961,3.961,0,0,1,35.454,26.734Z",
    transform: "translate(-4 -5.5)",
    style: r.line
  }), U.createElement("path", {
    d: "M12.855,24.936a7.679,7.679,0,0,0,1.258.238,8.939,8.939,0,0,0,.943.055c2.156,0,4.34-.772,4.34-2.248a1.9,1.9,0,0,0-1.314-1.637,6.4,6.4,0,0,0-1.9-.5A8.5,8.5,0,0,0,12.4,21.2a2.6,2.6,0,0,0-1.544,1.19,1.4,1.4,0,0,0-.142.593,1.571,1.571,0,0,0,.618,1.192A3.991,3.991,0,0,0,12.855,24.936Zm1.232-2.654a7.417,7.417,0,0,1,.969-.065,7,7,0,0,1,1.524.159,2.48,2.48,0,0,1,1.323.581c-.082.219-1.019.759-2.741.782-.037,0-.068,0-.106,0-.155,0-.3-.009-.44-.017a5.436,5.436,0,0,1-1.993-.437A1.018,1.018,0,0,1,12.21,23C12.277,22.825,12.92,22.434,14.087,22.282Z",
    transform: "translate(-2.848 -3.011)",
    style: r.line
  }))));
},
    at = function at(e) {
  var t = e.styles,
      r = n(n({}, Ue), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 48 48"
  }, U.createElement("g", {
    transform: "translate(-100)"
  }, U.createElement("rect", {
    style: r.bg,
    transform: "translate(100)"
  }), U.createElement("g", {
    transform: "translate(107.2 7.775)"
  }, U.createElement("path", {
    d: "M121.913,6.72c-4.04-.013-8.1.414-12.121,0a3.834,3.834,0,0,0-3.03.606c-1.375,1.277-.583,3.908,0,6.754,1.313,6.41,2.678,19.356,2.858,21.43a3.372,3.372,0,0,0,.95,2.294,3.475,3.475,0,0,0,2.53.644c3.485-.2,18.983-.05,20.558-.011a2.823,2.823,0,0,0,1.934-.547,3.069,3.069,0,0,0,.866-2.078c1.036-8.742,1.423-17.579,3.03-26.234a2.945,2.945,0,0,0-.347-2.424c-.772-.878-2.332-.671-2.857-.606C134.544,6.762,130.334,6.748,121.913,6.72Z",
    transform: "translate(-106 -6.479)",
    style: r.line
  }), U.createElement("path", {
    d: "M108.615,13.345c-.065-1.638-.126-2.809-.173-3.636a1.767,1.767,0,0,1,.259-1.385c.552-.58,1.716-.256,1.991-.174",
    transform: "translate(-105.515 -6.178)",
    style: r.line
  }), U.createElement("path", {
    d: "M109.688,13.928c.829-.857,2.33-.634,3.116-.52,3.94.572,7.91.9,11.862,1.386,3.372.412,5.058.617,6.493.346,2.324-.438,4.23-1.47,4.936-.692.4.444.192,1.234.086,1.645-.962,3.778-.839,7.756-1.471,11.6-.562,3.409-.678,2.76-.742,3.55-.078.953-.029,1.567-.473,2.054a2.9,2.9,0,0,1-2.394.553c-3.439-.36-7.609-.38-8.562-.368-2.928.035-6.691.748-9.451.335a2.463,2.463,0,0,1-1.669-.841,3,3,0,0,1-.259-1.992,53.106,53.106,0,0,0-.866-6.84c-.322-1.957-.814-4.2-1.126-7.619A3.238,3.238,0,0,1,109.688,13.928Z",
    transform: "translate(-105.376 -5.116)",
    style: r.line
  }), U.createElement("path", {
    d: "M111.8,18.99c.77-1.734,1.156-2.6,1.732-3.03a5,5,0,0,1,3.637-.606,5.243,5.243,0,0,1,2.077.606,6.182,6.182,0,0,1,2.6,3.463,3.478,3.478,0,0,1,.433,1.9c-.181.944-.9,1.061-2.425,2.857-.787.928-.816,1.156-1.3,1.385s-.7.127-2.6,0c-1.666-.11-2.17-.08-2.684-.52a3.03,3.03,0,0,1-.606-.865c-1.027-1.728-1.542-2.6-1.559-3.2A5.78,5.78,0,0,1,111.8,18.99Z",
    transform: "translate(-104.978 -4.722)",
    style: r.line
  }), U.createElement("path", {
    d: "M115,19.595",
    transform: "translate(-104.199 -3.856)",
    style: r.line
  }), U.createElement("path", {
    d: "M115,20.345l3.463-4.5Z",
    transform: "translate(-104.199 -4.606)",
    style: r.line
  }), U.createElement("path", {
    d: "M111.284,19.307l4.465.346,2.771,5.108",
    transform: "translate(-104.943 -3.913)",
    style: r.line
  }), U.createElement("path", {
    d: "M128.95,20.79c1.313,1.369,1.97,2.053,2.148,2.75a5,5,0,0,1-.816,3.6,5.293,5.293,0,0,1-1.349,1.693,6.181,6.181,0,0,1-4.189,1.091,3.472,3.472,0,0,1-1.926-.32c-.806-.526-.642-1.232-1.727-3.326-.559-1.08-.76-1.194-.79-1.727s.148-.695.984-2.4c.734-1.5.9-1.976,1.5-2.287a3.07,3.07,0,0,1,1.031-.233c1.988-.3,2.994-.44,3.556-.228A5.754,5.754,0,0,1,128.95,20.79Z",
    transform: "translate(-103.14 -3.916)",
    style: r.line
  }), U.createElement("path", {
    d: "M123.587,23.834",
    transform: "translate(-102.482 -3.008)",
    style: r.line
  }), U.createElement("path", {
    d: "M125.115,23.147l2.855,4.912Z",
    transform: "translate(-102.177 -3.145)",
    style: r.line
  }), U.createElement("path", {
    d: "M128.09,19.813l-2.012,4-5.777.629",
    transform: "translate(-103.139 -3.812)",
    style: r.line
  }))));
},
    lt = function lt(e) {
  var t = e.styles,
      r = e.color,
      a = void 0 === r ? "#0f191b" : r,
      l = n(n({}, De), t);
  return U.createElement("svg", {
    style: l.svg,
    viewBox: "0 0 32 32"
  }, U.createElement("rect", {
    id: "Area",
    width: "32",
    height: "32",
    fill: "#fcfcfc",
    opacity: "0"
  }), U.createElement("g", {
    transform: "translate(2.667 4)"
  }, U.createElement("path", {
    d: "M24,10.667h1.333a5.333,5.333,0,1,1,0,10.666H24",
    transform: "translate(-2.667 -4)",
    fill: "none",
    stroke: a,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2"
  }), U.createElement("path", {
    "data-name": "Path",
    d: "M2.667,10.667H24v12A5.333,5.333,0,0,1,18.667,28H8a5.333,5.333,0,0,1-5.333-5.333Z",
    transform: "translate(-2.667 -4)",
    fill: "none",
    stroke: a,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2"
  }), U.createElement("line", {
    y2: "4",
    transform: "translate(5.333 -2.667)",
    fill: "none",
    stroke: a,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2"
  }), U.createElement("line", {
    "data-name": "Line",
    y2: "4",
    transform: "translate(10.667 -2.667)",
    fill: "none",
    stroke: a,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2"
  }), U.createElement("line", {
    "data-name": "Line",
    y2: "4",
    transform: "translate(16 -2.667)",
    fill: "none",
    stroke: a,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2"
  })));
},
    st = function st(e) {
  var t = e.styles,
      r = n(n({}, Ue), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 48 48"
  }, U.createElement("g", {
    id: "wine-icon-2",
    transform: "translate(-150)"
  }, U.createElement("rect", {
    style: r.bg,
    transform: "translate(150)"
  }), U.createElement("g", {
    transform: "translate(163.854 5.446)"
  }, U.createElement("path", {
    d: "M181.752,7.331a.2.2,0,0,0,.025-.3c-2.437-2.492-6.76-2.6-10.022-2.44-1.975.1-7.214-.013-7.961,2.228a.134.134,0,0,0-.226.053c-1.1,5.975-.529,15.061,6.389,16.777a80.945,80.945,0,0,1-.758,12.5.08.08,0,0,0-.046.016c-1.49,1.3-8.108.07-7.578,3.388a.074.074,0,0,0,.035.055c.064,1.939,5.244,1.885,6.334,1.913,3.121.078,10.331.865,12.084-2.622a.131.131,0,0,0-.059-.18,1.658,1.658,0,0,0-.984-1.673c-1.9-1.043-4.516.09-6.413-1.009a.2.2,0,0,0-.061-.022,56.879,56.879,0,0,1-.428-12.085C180.553,24.166,182,13.867,181.752,7.331Zm-9.125,30.952a.156.156,0,0,0,.052.078.145.145,0,0,0,.218-.152c-.125-.61-.234-1.214-.332-1.814,1.944,1.066,6.865-.439,7.11,2.537-1.679,2.441-6.257,2.168-8.782,2.249-1.348.042-9.341.432-9.017-2.088a2.719,2.719,0,0,1,1.61-1.357c.317-.1.646-.163.971-.229a28.3,28.3,0,0,1,2.922-.326,2.575,2.575,0,0,0,1.756-.69c-.088.5-.179,1.009-.288,1.52a.129.129,0,0,0,.194.138.156.156,0,0,0,.05-.071,28.572,28.572,0,0,0,1.192-8.34c-.06-1.266-.15-3.349-.217-6.067a9.106,9.106,0,0,0,1.278.214c.193.018.378.024.565.032a42.853,42.853,0,0,1-.074,6.739A25.207,25.207,0,0,0,172.627,38.283Zm-1.254-14.8c-8.27-.791-8.052-10.225-7.555-16.456,1.711-2.041,6.623-2.057,9.022-2.064,2.892-.01,6.444.2,8.612,2.333C181.422,13.811,180.386,24.343,171.373,23.48Z",
    transform: "translate(-161.545 -4.539)",
    style: r.line
  }), U.createElement("path", {
    d: "M178.382,12.371a.094.094,0,0,0-.113.049l0,0a24.507,24.507,0,0,0-13.423-.742c-.013,0-.018.011-.026.019a.074.074,0,0,0-.118.054c-.337,4.139,2.028,8.585,6.494,9.048,4.984.517,6.936-4.309,7.412-8.426C178.621,12.237,178.408,12.237,178.382,12.371Zm-13.537-.55c.006,0,.01.006.016,0a29.333,29.333,0,0,1,13.241.838c-1.188,1.512-5.2,1.423-6.653,1.309a16.983,16.983,0,0,1-6.6-2.092C164.847,11.862,164.846,11.841,164.845,11.821Zm5.981,8.653c-4.186-.781-5.826-4.579-5.97-8.419a14.092,14.092,0,0,0,7.846,2.214c1.576-.012,4.618-.038,5.627-1.494C177.781,16.766,175.719,21.386,170.826,20.474Z",
    transform: "translate(-160.921 -3.227)",
    fill: "#1d1d1b",
    stroke: "#000",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "0.539"
  }), U.createElement("path", {
    d: "M180.092,6.79c-.072-.251-.3-.526-.587-.5a.133.133,0,0,0-.067.245.789.789,0,0,1,.336.33.63.63,0,0,1,.059.328.178.178,0,0,0-.085.042c-1.788,1.63-5.437,1.172-7.688,1.2-2.424.026-5.488.247-7.572-1.2a.522.522,0,0,1-.106-.445.681.681,0,0,1,.646-.454.087.087,0,0,0,.023-.17.767.767,0,0,0-.991.451c-.125.346.01.948.434,1.012A.139.139,0,0,0,164.6,7.6c2.029,1.6,5.584,1.206,7.955,1.192s5.6.544,7.442-1.3a.16.16,0,0,0,.038-.185A.715.715,0,0,0,180.092,6.79Z",
    transform: "translate(-161.051 -4.222)",
    style: r.line
  }))));
},
    ct = function ct(e) {
  var t = e.styles,
      r = e.color,
      a = void 0 === r ? "#3e3e3e" : r,
      l = n(n({}, Ue), t);
  return U.createElement("svg", {
    style: l.svg,
    viewBox: "0 0 33.5 33.5"
  }, U.createElement("g", {
    transform: "translate(0.75 0.75)"
  }, U.createElement("g", {
    transform: "translate(0)"
  }, U.createElement("rect", {
    width: "32",
    height: "32",
    fill: "none",
    stroke: a,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1.5",
    opacity: "0"
  }), U.createElement("g", {
    transform: "translate(4.886 0.8)"
  }, U.createElement("g", null, U.createElement("path", {
    d: "M13.2,10.322V1.506A.507.507,0,0,0,12.693,1H9.653a.507.507,0,0,0-.506.506v8.816a5.968,5.968,0,0,0-3.04,5.224V30.894a.506.506,0,0,0,.506.506h9.12a.507.507,0,0,0,.507-.506V15.547A5.972,5.972,0,0,0,13.2,10.322Z",
    transform: "translate(-6.107 -1)",
    fill: "none",
    stroke: a,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1.5"
  }))), U.createElement("g", {
    transform: "translate(18.123 10.426)"
  }, U.createElement("g", null, U.createElement("path", {
    d: "M31.6,19.807l-.907-6.338a.506.506,0,0,0-.5-.435h-6.08a.508.508,0,0,0-.5.435l-.906,6.31a4.275,4.275,0,0,0,.089,1.711l.089.371a4.4,4.4,0,0,0,4.27,3.332h.008a4.4,4.4,0,0,0,4.266-3.314l.083-.354A4.271,4.271,0,0,0,31.6,19.807Z",
    transform: "translate(-22.653 -13.033)",
    fill: "none",
    stroke: a,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1.5"
  }))), U.createElement("g", {
    transform: "translate(19.072 28.16)"
  }, U.createElement("g", null, U.createElement("path", {
    d: "M28.4,35.2H26.374a2.537,2.537,0,0,0-2.534,2.534.506.506,0,0,0,.506.506h6.08a.506.506,0,0,0,.507-.506A2.537,2.537,0,0,0,28.4,35.2Z",
    transform: "translate(-23.84 -35.2)",
    fill: "none",
    stroke: a,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1.5"
  })))), U.createElement("g", {
    transform: "translate(7.52 3.333)"
  }, U.createElement("g", {
    transform: "translate(0.911)"
  }, U.createElement("g", null, U.createElement("line", {
    x2: "3.04",
    fill: "none",
    stroke: a,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1.5"
  }))), U.createElement("g", {
    transform: "translate(11.044 14.187)"
  }, U.createElement("g", null, U.createElement("line", {
    x2: "8.107",
    fill: "none",
    stroke: a,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1.5"
  }))), U.createElement("g", {
    transform: "translate(0.911 4.56)"
  }, U.createElement("g", null, U.createElement("line", {
    x2: "3.04",
    fill: "none",
    stroke: a,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1.5"
  }))), U.createElement("g", {
    transform: "translate(0 14.187)"
  }, U.createElement("g", null, U.createElement("path", {
    d: "M14.264,21.9H9.4v8.106h4.864Z",
    transform: "translate(-9.4 -21.9)",
    fill: "none",
    stroke: a,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1.5"
  }))), U.createElement("line", {
    y2: "5.121",
    transform: "translate(15.098 19.253)",
    fill: "none",
    stroke: a,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1.5"
  }))));
},
    ot = function ot(e) {
  var t = e.styles,
      r = n(n({}, Te), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    id: "Area",
    width: "28",
    height: "28",
    fill: "#fcfcfc",
    opacity: "0"
  }), U.createElement("g", {
    id: "Icon",
    transform: "translate(4.666 3.5)"
  }, U.createElement("path", {
    id: "Path",
    d: "M25.667,3.5H2.333l9.334,11.037v7.63L16.333,24.5V14.537Z",
    transform: "translate(-4.666 -3.5)",
    fill: "none",
    stroke: "#0f191b",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1.5"
  })));
};

function it(e) {
  var t = e.styles,
      r = n(n({}, Te), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M24.5 17.5a2.334 2.334 0 01-2.334 2.334h-14L3.5 24.5V5.834A2.333 2.333 0 015.834 3.5h16.332A2.333 2.333 0 0124.5 5.834zM14.001 15.4v-7M10.501 11.9h7"
  }));
}

function ut(e) {
  var t = e.styles,
      r = n(n({}, Te), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("g", {
    transform: "translate(2.333 2.333)"
  }, U.createElement("circle", {
    style: r.line,
    cx: 11.667,
    cy: 11.667,
    r: 11.667
  }), U.createElement("path", {
    style: r.line,
    d: "M11.667 7v9.333M7 11.667h9.333"
  })));
}

function ft(e) {
  var t = e.styles,
      r = n(n({}, $e), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 20 20"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("g", {
    transform: "translate(1.29 2.499)"
  }, U.createElement("circle", {
    style: r.line,
    cx: 8.333,
    cy: 8.333,
    r: 8.333,
    transform: "translate(.377 -.832)"
  }), U.createElement("path", {
    style: r.line,
    d: "M8.71 4.168v3.333M8.71 10.834h.008"
  })));
}

function mt(e) {
  var t = e.styles,
      r = n(n({}, Te), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M24.5 9.334V24.5h-21V9.334M1.167 3.5h25.667v5.833H1.167zM11.667 14h4.667"
  }));
}

function yt(e) {
  var t = e.styles,
      r = n(n({}, Te), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M1.166 8.166L5.834 3.5 10.5 8.166"
  }), U.createElement("path", {
    style: r.line,
    d: "M12.834 24.5H10.5a4.666 4.666 0 01-4.666-4.666V3.5M26.834 19.834L22.166 24.5 17.5 19.834"
  }), U.createElement("path", {
    style: r.line,
    d: "M15.166 3.5H17.5a4.666 4.666 0 014.666 4.666V24.5"
  }));
}

function pt(e) {
  var t = e.styles,
      r = n(n({}, Te), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M14 5.833v16.333M22.167 14L14 22.167 5.833 14"
  }));
}

function dt(e) {
  var t = e.styles,
      r = n(n({}, Te), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M22.167 14H5.834M14 22.167L5.833 14 14 5.833"
  }));
}

function vt(e) {
  var t = e.styles,
      r = n(n({}, Te), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M5.834 14h16.333M14 5.833L22.167 14 14 22.167"
  }));
}

function ht(e) {
  var t = e.styles,
      r = n(n({}, Te), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M14 22.166V5.833M5.834 13.999L14 5.833l8.167 8.166"
  }));
}

function gt(e) {
  var t = e.styles,
      r = n(n({}, Te), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("g", {
    transform: "rotate(-90 14 11.666)"
  }, U.createElement("rect", {
    style: r.line,
    width: 15.167,
    height: 15.167,
    rx: 2,
    transform: "translate(8.166 8.166)"
  }), U.createElement("path", {
    style: r.line,
    d: "M3.5 15.166H2.333A2.333 2.333 0 010 12.833v-10.5A2.333 2.333 0 012.333 0h10.5a2.333 2.333 0 012.333 2.333V3.5"
  })));
}

function Et(e) {
  var t = e.styles,
      r = n(n({}, Te), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M24.5 17.5v4.666a2.333 2.333 0 01-2.334 2.334H5.834A2.333 2.333 0 013.5 22.166V17.5M8.166 11.666L14 17.5l5.833-5.834M14 17.5v-14"
  }));
}

function bt(e) {
  var t = e.styles,
      r = n(n({}, Te), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M3.5 9.8h21M3.5 18.2h21"
  }));
}

function wt(e) {
  var t = e.styles,
      r = n(n({}, Te), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("g", {
    transform: "translate(2.334 2.334)"
  }, U.createElement("rect", {
    style: r.line,
    width: 15.167,
    height: 15.167,
    rx: 2,
    transform: "translate(8.166 8.166)"
  }), U.createElement("path", {
    style: r.line,
    d: "M3.5 15.166H2.333A2.333 2.333 0 010 12.833v-10.5A2.333 2.333 0 012.333 0h10.5a2.333 2.333 0 012.333 2.333V3.5"
  }), U.createElement("path", {
    style: r.line,
    d: "M15.866 11.666v8.4M11.666 15.866h8.4"
  })));
}

function Mt(e) {
  var t = e.styles,
      r = n(n({}, Te), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M16.333 2.334H7a2.334 2.334 0 00-2.334 2.333v18.667A2.334 2.334 0 007 25.667h14a2.334 2.334 0 002.333-2.333v-14z"
  }), U.createElement("path", {
    style: r.line,
    d: "M16.334 2.334v7h7M18.666 15.167H9.333M18.666 19.834H9.333M11.667 10.5H9.334"
  }));
}

function xt(e) {
  var t = e.styles,
      r = n(n({}, Te), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M3.5 3.5h8.167v8.167H3.5zM16.333 3.5H24.5v8.167h-8.167zM16.333 16.333H24.5V24.5h-8.167zM3.5 16.333h8.167V24.5H3.5z"
  }));
}

function At(e) {
  var t = e.styles,
      r = n(n({}, Te), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M20.93 20.93a11.749 11.749 0 01-6.93 2.4C5.833 23.333 1.167 14 1.167 14a21.534 21.534 0 015.9-6.93m4.48-2.123A10.633 10.633 0 0114 4.667C22.167 4.667 26.833 14 26.833 14a21.547 21.547 0 01-2.52 3.722m-7.84-1.249a3.5 3.5 0 11-4.946-4.946M1.166 1.166l25.667 25.667"
  }));
}

function kt(e) {
  var t = e.styles,
      r = n(n({}, Te), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M1.166 4.666v7h7M26.834 23.334v-7h-7"
  }), U.createElement("path", {
    style: r.line,
    d: "M23.905 10.501A10.5 10.5 0 006.58 6.58l-5.414 5.086m25.667 4.668l-5.414 5.086a10.5 10.5 0 01-17.324-3.919"
  }));
}

function _t(e) {
  var t = e.styles,
      r = n(n({}, Te), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("g", {
    transform: "translate(.998 4.666)"
  }, U.createElement("path", {
    style: r.line,
    d: "M0 9.334S4.668 0 12.834 0s12.834 9.334 12.834 9.334S21 18.668 12.834 18.668 0 9.334 0 9.334z"
  }), U.createElement("circle", {
    style: r.line,
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(9.334 5.834)"
  })));
}

function Ct(e) {
  var t = e.styles,
      r = n(n({}, Te), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("g", {
    transform: "translate(3.5 3.5)"
  }, U.createElement("circle", {
    style: r.line,
    cx: 9.333,
    cy: 9.333,
    r: 9.333
  }), U.createElement("path", {
    style: r.line,
    d: "M21 21l-5.075-5.075"
  })));
}

function St(e) {
  var t = e.styles,
      r = n(n({}, Te), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M1.166 4.666v7h7"
  }), U.createElement("path", {
    style: r.line,
    d: "M4.095 17.503A10.5 10.5 0 106.58 6.58l-5.414 5.086"
  }));
}

function It(e) {
  var t = e.styles,
      r = n(n({}, Te), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M19.833 12.834L14 7l-5.834 5.834M19.833 21l-5.834-5.834L8.166 21"
  }));
}

function Ot(e) {
  var t = e.styles,
      r = n(n({}, Te), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M8.166 15.166L14 21l5.833-5.834M8.166 7L14 12.834 19.833 7"
  }));
}

function jt(e) {
  var t = e.styles,
      r = n(n({}, Te), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M9.333 7H24.5M9.333 14H24.5M9.333 21H24.5M3.5 7h.012M3.5 14h.012M3.5 21h.012"
  }));
}

function Pt(e) {
  var t = e.styles,
      r = n(n({}, Te), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M21 23.334V11.667M14 23.334V4.667M7 23.334v-7"
  }));
}

function Rt(e) {
  var t = e.styles,
      r = n(n({}, Te), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("g", {
    transform: "translate(3.5 3.5)"
  }, U.createElement("rect", {
    style: r.line,
    width: 21,
    height: 21,
    rx: 2
  }), U.createElement("circle", {
    style: r.line,
    cx: 1.75,
    cy: 1.75,
    r: 1.75,
    transform: "translate(4.667 4.667)"
  }), U.createElement("path", {
    style: r.line,
    d: "M21 14l-5.833-5.834L2.334 21"
  })));
}

function Bt(e) {
  var t = e.styles,
      r = n(n({}, $e), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 20 20"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M5 5l10 10M5 15L15 5"
  }));
}

function Vt(e) {
  var t = e.styles,
      r = n(n({}, $e), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("g", {
    transform: "translate(2.333 2.333)"
  }, U.createElement("circle", {
    cx: 11.667,
    cy: 11.667,
    r: 11.667,
    fill: "#e84961"
  }), U.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7 11.667h9.333"
  })));
}

function zt(e) {
  var t = e.styles,
      r = n(n({}, Ne), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 21.135 20.383"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M18.272 12.691a8.165 8.165 0 01-5.581 5.471A8.317 8.317 0 119.864 1.899"
  }), U.createElement("path", {
    style: r.line,
    d: "M18.661 3.512l-8.333 8.342-2.5-2.5"
  }));
}

function $t(e) {
  var t = e.styles,
      r = n(n({}, Ne), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 80 80"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M73.332 36.933v3.068A33.332 33.332 0 1153.568 9.533"
  }), U.createElement("path", {
    style: r.line,
    d: "M73.332 13.332L40 46.699l-10-10"
  }));
}

function Ht(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M24.5 9.334V24.5h-21V9.334M1.167 3.5h25.667v5.833H1.167zM10.337 13.369l7.094 7.094M10.337 20.464l7.094-7.094"
  }));
}

function Lt(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M12.005 4.503l-9.881 16.5a2.333 2.333 0 001.994 3.5h19.764a2.334 2.334 0 002-3.5L16 4.503a2.334 2.334 0 00-3.991 0zM14 10.5v4.667M14 19.834h.012"
  }));
}

function Zt(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M21 11.667H7M24.5 7h-21M24.5 16.333h-21M21 21H7"
  }));
}

function Tt(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M19.833 11.667H3.5M24.5 7h-21M24.5 16.333h-21M19.833 21H3.5"
  }));
}

function Nt(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M24.5 11.667H8.167M24.5 7h-21M24.5 16.333h-21M24.5 21H8.167"
  }));
}

function Dt(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M24.5 9.334V24.5h-21V9.334M1.167 3.5h25.667v5.833H1.167zM11.667 14h4.667"
  }));
}

function Ft(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M7 4.667h9.333a4.667 4.667 0 110 9.333H7z"
  }), U.createElement("path", {
    style: r.line,
    d: "M7 14h10.5a4.667 4.667 0 110 9.333H7z"
  }));
}

function Ut(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    d: "M21 17.5l-7-7-7 7",
    style: r.line
  }));
}

function qt(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("g", {
    transform: "translate(3.5 2.333)"
  }, U.createElement("rect", {
    style: r.line,
    width: 21,
    height: 21,
    rx: 2,
    transform: "translate(0 2.333)"
  }), U.createElement("path", {
    style: r.line,
    d: "M15.167 0v4.667M5.833 0v4.667M0 9.333h21"
  })));
}

function Wt(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("g", {
    transform: "translate(7 10.5)"
  }, U.createElement("rect", {
    style: r.line,
    width: 25.667,
    height: 18.667,
    rx: 2,
    transform: "translate(-5.833 -5.833)"
  }), U.createElement("path", {
    style: r.line,
    d: "M-5.833 1.167h25.667"
  })));
}

function Yt(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    d: "M7 10.5l7 7 7-7",
    style: r.line
  }));
}

function Gt(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    d: "M17.5 21l-7-7 7-7",
    style: r.line
  }));
}

function Jt(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    d: "M10.5 21l7-7-7-7",
    style: r.line
  }));
}

function Xt(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M1.167 7v18.667L9.333 21l9.334 4.667L26.833 21V2.333L18.667 7 9.333 2.333zM9.333 2.333V21M18.667 7v18.667"
  }));
}

function Kt(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M25.667 12.927v1.074a11.666 11.666 0 11-6.918-10.664"
  }), U.createElement("path", {
    style: r.line,
    d: "M25.666 4.667L14 16.346l-3.5-3.5"
  }));
}

function Qt(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("g", {
    transform: "translate(5.833 1.167)"
  }, U.createElement("circle", {
    style: r.line,
    cx: 8.167,
    cy: 8.167,
    r: 8.167
  }), U.createElement("path", {
    style: r.line,
    d: "M3.745 15.033L2.334 25.666l5.833-3.5 5.833 3.5-1.411-10.64"
  })));
}

function er(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M19.768 19.996A9.49 9.49 0 0114 21.875C6.761 21.875 2.625 14 2.625 14a18.44 18.44 0 015.233-5.847m3.97-1.795A9.88 9.88 0 0114 6.122c7.239 0 11.375 7.875 11.375 7.875a18.16 18.16 0 01-2.234 3.141m-7.053-1.023a3 3 0 01-2.932.82 3.029 3.029 0 01-2.238-2.131 2.86 2.86 0 01.891-2.891M2.625 2.625l22.75 22.75"
  }));
}

function tr(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("g", {
    transform: "translate(2.625 6.125)"
  }, U.createElement("path", {
    style: r.line,
    d: "M0 7.875S4.137 0 11.375 0 22.75 7.875 22.75 7.875s-4.137 7.875-11.375 7.875S0 7.875 0 7.875z"
  }), U.createElement("ellipse", {
    style: r.line,
    cx: 3.102,
    cy: 2.953,
    rx: 3.102,
    ry: 2.953,
    transform: "translate(8.273 4.922)"
  })));
}

function rr(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    d: "M21 2.334h-3.5a5.833 5.833 0 00-5.834 5.833v3.5h-3.5v4.668h3.5v9.332h4.667v-9.333h3.5L21 11.667h-4.667v-3.5a1.166 1.166 0 011.166-1.166h3.5z",
    style: r.line
  }));
}

function nr(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M4.667 8.167v-3.5h18.666v3.5M10.5 23.334h7M14 4.667v18.667"
  }));
}

function ar(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M14 2.333L2.333 8.167 14 14l11.667-5.833zM2.333 19.833L14 25.667l11.667-5.834M2.333 14L14 19.833 25.667 14"
  }));
}

function lr(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("g", {
    transform: "translate(2.333 2.333)"
  }, U.createElement("circle", {
    style: r.line,
    cx: 11.667,
    cy: 11.667,
    r: 11.667
  }), U.createElement("path", {
    style: r.line,
    d: "M11.667 4.667v7L16.334 14"
  })));
}

function sr(e) {
  var t = e.styles,
      r = n(n({}, Le), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M22.473 5.589h-1.644L19.4 3.3a.644.644 0 00-.547-.3H9.146a.644.644 0 00-.546.3L7.171 5.589H5.527A2.53 2.53 0 003 8.116v14.357A2.53 2.53 0 005.527 25h16.946A2.53 2.53 0 0025 22.473V8.116a2.53 2.53 0 00-2.527-2.527zm-14.151.59L9.309 4.6l3.66 2.928-2.114 1.691zm11.357 0l-2.534 3.04-2.113-1.691L18.691 4.6zM14 6.7l-3.017-2.411h6.033zm-.511 5.353h1.022L15.9 21.54l-1.9 1.9-1.9-1.9zm1.057-1.289h-1.092L13.1 9.077l.9-.724.9.724zM4.289 22.473V8.116a1.239 1.239 0 011.238-1.238h1.7l3.042 3.651a.644.644 0 00.9.091l.8-.642.309 1.454-1.5 10.241a.645.645 0 00.182.549l1.489 1.489H5.527a1.239 1.239 0 01-1.238-1.238zm19.422 0a1.239 1.239 0 01-1.238 1.238h-6.917l1.489-1.489a.644.644 0 00.182-.549l-1.5-10.241.309-1.454.8.642a.645.645 0 00.9-.091l3.043-3.651h1.7a1.239 1.239 0 011.238 1.238z"
  }), U.createElement("path", {
    style: r.line,
    d: "M21.766 13.355h-3.47a.645.645 0 000 1.289h3.47a.645.645 0 000-1.289z"
  }));
}

function cr(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    d: "M24.5 17.5a2.333 2.333 0 01-2.333 2.333h-14L3.5 24.5V5.833A2.334 2.334 0 015.833 3.5h16.334A2.334 2.334 0 0124.5 5.833z",
    style: r.line
  }));
}

function or(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("g", {
    transform: "translate(4.667 2.333)"
  }, U.createElement("path", {
    style: r.line,
    d: "M14 2.334h2.333a2.332 2.332 0 012.333 2.333V21a2.333 2.333 0 01-2.333 2.334h-14A2.333 2.333 0 010 21V4.667a2.332 2.332 0 012.333-2.333h2.333"
  }), U.createElement("rect", {
    style: r.line,
    width: 9.333,
    height: 4.667,
    rx: 1,
    transform: "translate(4.666)"
  })));
}

function ir(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M24.745 18.538A11.666 11.666 0 119.333 3.3M25.667 14A11.668 11.668 0 0014 2.333V14z"
  }));
}

function ur(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M21 9.333h1.167a4.667 4.667 0 010 9.334H21"
  }), U.createElement("path", {
    style: r.line,
    d: "M2.333 9.333H21v10.5a4.666 4.666 0 01-4.667 4.667H7a4.667 4.667 0 01-4.667-4.667zM7 1.167v3.5M11.667 1.167v3.5M16.333 1.167v3.5"
  }));
}

function fr(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M11.667 15.167a5.833 5.833 0 008.8.63l3.5-3.5a5.833 5.833 0 10-8.249-8.249l-2.006 2"
  }), U.createElement("path", {
    style: r.line,
    d: "M16.333 12.833a5.833 5.833 0 00-8.8-.63l-3.5 3.5a5.833 5.833 0 108.249 8.249l1.994-1.995"
  }));
}

function mr(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M4.667 4.667h18.666A2.34 2.34 0 0125.667 7v14a2.34 2.34 0 01-2.334 2.333H4.667A2.34 2.34 0 012.333 21V7a2.34 2.34 0 012.334-2.333z"
  }), U.createElement("path", {
    style: r.line,
    d: "M25.667 7L14 15.167 2.333 7"
  }));
}

function yr(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M4.667 17.5s1.166-1.167 4.666-1.167 5.834 2.334 9.334 2.334 4.666-1.167 4.666-1.167v-14s-1.166 1.167-4.666 1.167-5.834-2.334-9.334-2.334S4.667 3.5 4.667 3.5zM4.667 25.667V17.5"
  }));
}

function pr(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M22.166 4.667h-10.5M16.333 23.334h-10.5M17.5 4.667l-7 18.667"
  }));
}

function dr(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("g", {
    transform: "translate(3.5 2.333)"
  }, U.createElement("rect", {
    style: r.line,
    width: 21,
    height: 12.833,
    rx: 2,
    transform: "translate(0 10.5)"
  }), U.createElement("path", {
    style: r.line,
    d: "M4.667 10.5V5.834a5.833 5.833 0 1111.666 0V10.5"
  })));
}

function vr(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M14 2.333V7M14 21v4.667M5.751 5.751l3.302 3.302M18.946 18.946l3.302 3.302M2.333 14H7M21 14h4.667M5.751 22.248l3.302-3.302M18.946 9.053l3.302-3.302"
  }));
}

function hr(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M10.5 24.5H5.834A2.333 2.333 0 013.5 22.166V5.834A2.333 2.333 0 015.834 3.5H10.5M18.666 19.833l5.834-5.834-5.834-5.833M24.5 14h-14"
  }));
}

function gr(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M4.667 10.5h18.667M4.667 17.5h18.667M11.667 3.5l-2.333 21M18.667 3.5l-2.333 21"
  }));
}

function Er(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("g", {
    transform: "translate(5.833 2.333)"
  }, U.createElement("rect", {
    style: r.line,
    width: 16.333,
    height: 23.333,
    rx: 2
  }), U.createElement("path", {
    style: r.line,
    d: "M8.167 18.667h.012"
  })));
}

function br(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M21 9.333a7 7 0 10-14 0c0 8.167-3.5 10.5-3.5 10.5h21S21 17.5 21 9.333M16.018 24.5a2.332 2.332 0 01-4.036 0"
  }));
}

function wr(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("g", {
    transform: "translate(3.5 1.167)"
  }, U.createElement("path", {
    style: r.line,
    d: "M21 10.5c0 8.166-10.5 15.166-10.5 15.166S0 18.666 0 10.5a10.5 10.5 0 0121 0z"
  }), U.createElement("circle", {
    style: r.line,
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(7 7)"
  })));
}

function Mr(e) {
  var t = e.styles,
      r = n(n({}, Ze), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    d: "M20.038 13.226h-9.1V3.811c0-1-2.883-1.811-3.962-1.811h-.49a.447.447 0 00-.49.453v23.094a.492.492 0 00.981 0v-6.7h14.038v6.7a.492.492 0 00.981 0V15.038a1.9 1.9 0 00-1.958-1.812zM6.981 2.906c.539 0 2.981.408 2.981.906v9.415H6.981zm14.038 15.038H6.981v-3.812h13.057a.948.948 0 01.981.906z",
    style: r.line
  }));
}

function xr(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    d: "M24.5 11.667c0 8.166-10.5 15.166-10.5 15.166s-10.5-7-10.5-15.166a10.5 10.5 0 0121 0z",
    style: r.line
  }), U.createElement("path", {
    d: "M18.224 7.2V17H16.4v-4.2h-5.064V17h-1.82V7.2h1.82v4.046H16.4V7.2z"
  }));
}

function Ar(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("g", {
    transform: "translate(2.333 2.333)"
  }, U.createElement("rect", {
    style: r.line,
    width: 23.333,
    height: 23.333,
    rx: 5
  }), U.createElement("path", {
    style: r.line,
    d: "M16.333 10.932a4.666 4.666 0 11-3.931-3.931 4.666 4.666 0 013.931 3.931zM18.083 5.25h.012"
  })), U.createElement("g", {
    transform: "translate(2.333 2.333)"
  }, U.createElement("rect", {
    style: r.line,
    width: 23.333,
    height: 23.333,
    rx: 5
  }), U.createElement("path", {
    style: r.line,
    d: "M16.333 10.932a4.666 4.666 0 11-3.931-3.931 4.666 4.666 0 013.931 3.931zM18.083 5.25h.012"
  })));
}

function kr(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28.054 28.079"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    d: "M25.432 11.357l.15 1.063a11.666 11.666 0 11-8.334-9.597",
    style: r.line
  }), U.createElement("path", {
    style: r.line,
    d: "M8.428 8.438l11.2 11.2M8.428 19.645L23.129 4.944"
  }));
}

function _r(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("g", {
    transform: "translate(2.333 2.333)"
  }, U.createElement("circle", {
    style: r.line,
    cx: 11.667,
    cy: 11.667,
    r: 11.667
  }), U.createElement("path", {
    style: r.line,
    d: "M7 14a6.3 6.3 0 004.667 2.334A6.3 6.3 0 0016.334 14M8.167 8.167h.012M15.167 8.167h.012"
  })));
}

function Cr(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("g", {
    transform: "rotate(180 11.666 12.834)"
  }, U.createElement("rect", {
    style: r.line,
    width: 18.667,
    height: 23.333,
    rx: 2
  }), U.createElement("circle", {
    style: r.line,
    cx: 4.667,
    cy: 4.667,
    r: 4.667,
    transform: "translate(4.667 9.333)"
  }), U.createElement("path", {
    style: r.line,
    d: "M9.333 4.667h.012"
  })));
}

function Sr(e) {
  var t = e.styles,
      r = n(n({}, Le), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M7.982 9.762A.761.761 0 008.742 9V3.76a.76.76 0 10-1.519 0V9a.76.76 0 00.759.762z"
  }), U.createElement("path", {
    style: r.line,
    d: "M11.2 3a.761.761 0 00-.76.76v5.371a2.462 2.462 0 11-4.925 0V3.76A.76.76 0 104 3.76v5.371a4 4 0 003.145 3.892l.078.017v11.2a.76.76 0 101.519 0v-11.2l.078-.017a4 4 0 003.145-3.892V3.76A.761.761 0 0011.2 3zM22.962 5.24C22.17 3.8 21.124 3 20.018 3s-2.153.8-2.945 2.24a8.507 8.507 0 00-1.038 3.891 4 4 0 003.145 3.892l.078.017v11.2a.76.76 0 101.519 0v-11.2l.078-.017A4 4 0 0024 9.131a8.507 8.507 0 00-1.038-3.891zm-2.944 6.354a2.465 2.465 0 01-2.463-2.463 7.013 7.013 0 01.845-3.159c.5-.909 1.1-1.452 1.614-1.452s1.114.543 1.613 1.452a7.013 7.013 0 01.849 3.159 2.465 2.465 0 01-2.458 2.463z"
  }));
}

function Ir(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M26.297 7.49a3.244 3.244 0 00-2.263-2.333C22.027 4.667 14 4.667 14 4.667s-8.026 0-10.033.537a3.244 3.244 0 00-2.263 2.333 33.788 33.788 0 00-.537 6.172 33.883 33.883 0 00.537 6.218 3.244 3.244 0 002.263 2.24c2.007.537 10.033.537 10.033.537s8.027 0 10.033-.537a3.244 3.244 0 002.263-2.333 33.9 33.9 0 00.537-6.125 33.883 33.883 0 00-.536-6.219z"
  }), U.createElement("path", {
    style: r.line,
    d: "M11.375 17.524l6.708-3.81-6.708-3.82z"
  }));
}

function Or(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M9.17 2.333h9.663L25.67 9.17v9.663l-6.837 6.833H9.17l-6.837-6.833V9.17zM14 9.333V14M14 18.666h.012"
  }));
}

function jr(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M14 1.167v25.667M19.833 5.833h-8.75a4.083 4.083 0 000 8.167h5.834a4.083 4.083 0 010 8.167H7"
  }));
}

function Pr(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    d: "M14 2.333L22.167 24.5 14 19.833 5.833 24.5z",
    style: r.line
  }));
}

function Rr(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("g", {
    transform: "translate(2.333 3.5)"
  }, U.createElement("rect", {
    style: r.line,
    width: 23.333,
    height: 16.333,
    rx: 2,
    transform: "translate(0 4.667)"
  }), U.createElement("path", {
    style: r.line,
    d: "M16.334 21V2.333A2.334 2.334 0 0014 0H9.334A2.334 2.334 0 007 2.333V21"
  })));
}

function Br(e) {
  var t = e.styles,
      r = n(n({}, Ze), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    d: "M14 1.167C8.579 1.167 1.167 5.267 1.167 14A12.754 12.754 0 0014 26.834c9.787 0 12.833-8.574 12.833-12.833A12.729 12.729 0 0014 1.167zm-2.976 1.208A11.459 11.459 0 007.857 7.75a11.923 11.923 0 01-2.542-2.026 12.024 12.024 0 015.709-3.349zM4.767 6.341a12.582 12.582 0 002.862 2.233 21.7 21.7 0 00-.657 5.012H2.006a11.953 11.953 0 012.761-7.245zm0 15.319a11.922 11.922 0 01-2.761-7.245h4.966a21.662 21.662 0 00.657 5.012 12.954 12.954 0 00-2.862 2.233zm.551.621a11.923 11.923 0 012.539-2.026 11.485 11.485 0 003.168 5.376 12.106 12.106 0 01-5.71-3.35zm8.271 3.693c-2.152-.273-4.007-2.678-5.007-6.124a12.077 12.077 0 015.004-1.283v7.412zm0-8.236a12.854 12.854 0 00-5.219 1.3 21.673 21.673 0 01-.571-4.623h5.79zm0-4.153H7.796a21.673 21.673 0 01.571-4.618 12.9 12.9 0 005.219 1.3zm0-4.148a11.98 11.98 0 01-5.01-1.287c1-3.451 2.855-5.851 5.007-6.124zm9.65-3.1a11.953 11.953 0 012.759 7.245h-4.965a21.662 21.662 0 00-.657-5.012 12.811 12.811 0 002.86-2.229zm-.551-.621a11.923 11.923 0 01-2.541 2.026 11.511 11.511 0 00-3.171-5.375 12.106 12.106 0 015.71 3.352zm-8.273-3.69c2.152.273 4.007 2.678 5.007 6.124a12.057 12.057 0 01-5.007 1.288zm0 8.236a12.854 12.854 0 005.219-1.3 21.673 21.673 0 01.571 4.623h-5.79zm0 4.153h5.79a21.674 21.674 0 01-.571 4.623 12.694 12.694 0 00-5.219-1.3zm0 11.56v-7.408a11.98 11.98 0 015.007 1.288c-1.001 3.447-2.855 5.847-5.007 6.12zm2.562-.349a11.459 11.459 0 003.168-5.376 11.922 11.922 0 012.541 2.026 12.024 12.024 0 01-5.71 3.35zm6.26-3.966a12.811 12.811 0 00-2.86-2.233 21.7 21.7 0 00.657-5.012h4.962a11.953 11.953 0 01-2.76 7.245z",
    style: r.line
  }));
}

function Vr(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M8.4 12.6V7h11.2v5.6zM4.2 21v-5.6h15.4V21zM23.8 4.2v19.6"
  }));
}

function zr(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("g", {
    style: r.line
  }, U.createElement("path", {
    d: "M25.667 12.926V14a11.666 11.666 0 11-6.918-10.664",
    strokeLinejoin: "round"
  }), U.createElement("path", {
    d: "M9.1 13.993h11.2"
  })));
}

function $r(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M8.4 12.6V7h11.2v5.6zM8.4 21v-5.6h15.4V21zM4.2 4.2v19.6"
  }));
}

function Hr(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("g", {
    transform: "translate(3.5 3.5)"
  }, U.createElement("circle", {
    style: r.line,
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(14 14)"
  }), U.createElement("circle", {
    style: r.line,
    cx: 3.5,
    cy: 3.5,
    r: 3.5
  }), U.createElement("path", {
    style: r.line,
    d: "M11.667 3.5h3.5A2.334 2.334 0 0117.5 5.833V14M3.5 7v14"
  })));
}

function Lr(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M19.25 10.967L8.75 4.912M24.5 18.667V9.333a2.332 2.332 0 00-1.167-2.018l-8.166-4.667a2.339 2.339 0 00-2.334 0L4.667 7.315A2.332 2.332 0 003.5 9.333v9.334a2.332 2.332 0 001.167 2.018l8.166 4.667a2.339 2.339 0 002.334 0l8.166-4.667a2.332 2.332 0 001.167-2.018z"
  }), U.createElement("path", {
    style: r.line,
    d: "M3.815 8.12L14 14.012 24.185 8.12M14 25.76V14"
  }));
}

function Zr(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    d: "M14 2.333l3.6 7.3 8.062 1.178-5.829 5.689 1.377 8.026L14 20.732l-7.21 3.791L8.167 16.5l-5.834-5.685L10.4 9.637z",
    style: r.line
  }));
}

function Tr(e) {
  var t = e.styles,
      r = n(n({}, Ze), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 26.267 26.267"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    d: "M13.133.3C7.712.3.3 4.4.3 13.133a12.754 12.754 0 0012.833 12.834c9.787 0 12.833-8.574 12.833-12.833A12.729 12.729 0 0013.133.3zm-2.976 1.208A11.459 11.459 0 006.99 6.883a11.923 11.923 0 01-2.542-2.026 12.024 12.024 0 015.709-3.349zM3.9 5.474a12.582 12.582 0 002.862 2.233 21.7 21.7 0 00-.657 5.012H1.139A11.953 11.953 0 013.9 5.474zm0 15.319a11.922 11.922 0 01-2.761-7.245h4.966a21.662 21.662 0 00.657 5.012A12.954 12.954 0 003.9 20.793zm.551.621a11.923 11.923 0 012.539-2.026 11.485 11.485 0 003.168 5.376 12.106 12.106 0 01-5.71-3.35zm8.271 3.693c-2.152-.273-4.007-2.678-5.007-6.124a12.077 12.077 0 015.004-1.283v7.412zm0-8.236a12.854 12.854 0 00-5.219 1.3 21.673 21.673 0 01-.571-4.623h5.79zm0-4.153H6.929A21.673 21.673 0 017.5 8.1a12.9 12.9 0 005.219 1.3zm0-4.148a11.98 11.98 0 01-5.01-1.287c1-3.451 2.855-5.851 5.007-6.124zm9.65-3.1a11.953 11.953 0 012.759 7.245h-4.965a21.662 21.662 0 00-.657-5.012 12.811 12.811 0 002.86-2.229zm-.551-.621a11.923 11.923 0 01-2.541 2.026A11.511 11.511 0 0016.109 1.5a12.106 12.106 0 015.71 3.352zm-8.273-3.69c2.152.273 4.007 2.678 5.007 6.124a12.057 12.057 0 01-5.007 1.288zm0 8.236a12.854 12.854 0 005.219-1.3 21.673 21.673 0 01.571 4.623h-5.79zm0 4.153h5.79a21.674 21.674 0 01-.571 4.623 12.694 12.694 0 00-5.219-1.3zm0 11.56V17.7a11.98 11.98 0 015.007 1.288c-1.001 3.447-2.855 5.847-5.007 6.12zm2.562-.349a11.459 11.459 0 003.168-5.376 11.922 11.922 0 012.541 2.026 12.024 12.024 0 01-5.71 3.35zm6.26-3.966a12.811 12.811 0 00-2.86-2.233 21.7 21.7 0 00.657-5.012h4.962a11.953 11.953 0 01-2.76 7.245z",
    style: r.line
  }));
}

function Nr(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("g", {
    transform: "translate(2.333 2.333)"
  }, U.createElement("circle", {
    style: r.line,
    cx: 11.667,
    cy: 11.667,
    r: 11.667
  }), U.createElement("path", {
    style: r.line,
    d: "M11.667 7v4.667M11.667 16.333h.012"
  })));
}

function Dr(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    d: "M14 25.667S23.333 21 23.333 14V5.833L14 2.333l-9.333 3.5V14C4.667 21 14 25.667 14 25.667z",
    style: r.line
  }));
}

function Fr(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("g", {
    transform: "translate(4.666 3.5)"
  }, U.createElement("path", {
    style: r.line,
    d: "M18.667 21v-2.334A4.667 4.667 0 0014 14H4.667a4.667 4.667 0 00-4.668 4.666V21"
  }), U.createElement("circle", {
    style: r.line,
    cx: 4.667,
    cy: 4.667,
    r: 4.667,
    transform: "translate(4.667)"
  })));
}

function Ur(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M24.022 15.645l-8.365 8.365a2.335 2.335 0 01-3.3 0L2.333 14V2.333H14l10.022 10.022a2.335 2.335 0 010 3.29zM8.167 8.167h.012"
  }));
}

function qr(e) {
  var t = e.styles,
      r = n(n({}, He), t);
  return U.createElement("svg", {
    style: r.svg,
    viewBox: "0 0 28 28"
  }, U.createElement("rect", {
    style: r.bg
  }), U.createElement("path", {
    style: r.line,
    d: "M8.4 12.6V7h11.2v5.6zM6.3 21v-5.6h15.4V21zM14 4.2v19.6"
  }));
}

var Wr = function Wr(e) {
  var t = e.icon,
      r = e.styles;

  switch (t) {
    case "go-to":
      return U.createElement(qe, {
        styles: r
      });

    case "delete":
      return U.createElement(We, {
        styles: r
      });

    case "add-comment":
      return U.createElement(it, {
        styles: r
      });

    case "add":
      return U.createElement(ut, {
        styles: r
      });

    case "alert":
      return U.createElement(ft, {
        styles: r
      });

    case "archive":
      return U.createElement(mt, {
        styles: r
      });

    case "arrange":
      return U.createElement(yt, {
        styles: r
      });

    case "arrow-down":
      return U.createElement(pt, {
        styles: r
      });

    case "arrow-left":
      return U.createElement(dt, {
        styles: r
      });

    case "arrow-right":
      return U.createElement(vt, {
        styles: r
      });

    case "arrow-up":
      return U.createElement(ht, {
        styles: r
      });

    case "copy-down":
      return U.createElement(gt, {
        styles: r
      });

    case "download":
      return U.createElement(Et, {
        styles: r
      });

    case "drag":
      return U.createElement(bt, {
        styles: r
      });

    case "duplicate":
    case "duplicate":
      return U.createElement(wt, {
        styles: r
      });

    case "export":
    case "export":
      return U.createElement(Mt, {
        styles: r
      });

    case "gallery":
    case "gallery":
      return U.createElement(xt, {
        styles: r
      });

    case "hide-pass":
    case "hide-pass":
      return U.createElement(At, {
        styles: r
      });

    case "update":
    case "update":
      return U.createElement(kt, {
        styles: r
      });

    case "show-pass":
    case "show-pass":
      return U.createElement(_t, {
        styles: r
      });

    case "search":
    case "search":
      return U.createElement(Ct, {
        styles: r
      });

    case "reload":
    case "reload":
      return U.createElement(St, {
        styles: r
      });

    case "move-up":
    case "move-up":
      return U.createElement(It, {
        styles: r
      });

    case "move-down":
    case "move-down":
      return U.createElement(Ot, {
        styles: r
      });

    case "list":
    case "list":
      return U.createElement(jt, {
        styles: r
      });

    case "items-history":
    case "items-history":
      return U.createElement(Pt, {
        styles: r
      });

    case "image":
    case "image":
      return U.createElement(Rt, {
        styles: r
      });

    case "wrong":
    case "wrong":
      return U.createElement(Bt, {
        styles: r
      });

    case "remove":
    case "remove":
      return U.createElement(Vt, {
        styles: r
      });

    case "ok":
    case "ok":
      return U.createElement(zt, {
        styles: r
      });

    case "successfull":
    case "successfull":
      return U.createElement($t, {
        styles: r
      });

    case "add-user":
    case "add-user":
      return U.createElement(Ye, {
        styles: r
      });

    case "edit":
    case "edit":
      return U.createElement(Ge, {
        styles: r
      });

    case "not-found":
      return U.createElement(Ht, {
        styles: r
      });

    case "triangle-alert":
      return U.createElement(Lt, {
        styles: r
      });

    case "align-center":
      return U.createElement(Zt, {
        styles: r
      });

    case "align-left":
      return U.createElement(Tt, {
        styles: r
      });

    case "align-right":
      return U.createElement(Nt, {
        styles: r
      });

    case "archived":
      return U.createElement(Dt, {
        styles: r
      });

    case "bold":
      return U.createElement(Ft, {
        styles: r
      });

    case "chevron-up":
      return U.createElement(Ut, {
        styles: r
      });

    case "calendar":
      return U.createElement(qt, {
        styles: r
      });

    case "card":
      return U.createElement(Wt, {
        styles: r
      });

    case "chevron-down":
      return U.createElement(Yt, {
        styles: r
      });

    case "chevron-left":
      return U.createElement(Gt, {
        styles: r
      });

    case "chevron-right":
      return U.createElement(Jt, {
        styles: r
      });

    case "estate":
      return U.createElement(Xt, {
        styles: r
      });

    case "complete":
      return U.createElement(Kt, {
        styles: r
      });

    case "experience":
      return U.createElement(Qt, {
        styles: r
      });

    case "eye-off":
      return U.createElement(er, {
        styles: r
      });

    case "eye-on":
      return U.createElement(tr, {
        styles: r
      });

    case "facebook":
      return U.createElement(rr, {
        styles: r
      });

    case "font":
      return U.createElement(nr, {
        styles: r
      });

    case "footer-section-name":
      return U.createElement(ar, {
        styles: r
      });

    case "clock":
      return U.createElement(lr, {
        styles: r
      });

    case "concierge":
      return U.createElement(sr, {
        styles: r
      });

    case "comment":
      return U.createElement(cr, {
        styles: r
      });

    case "duties":
      return U.createElement(or, {
        styles: r
      });

    case "expiration":
      return U.createElement(ir, {
        styles: r
      });

    case "item":
      return U.createElement(ur, {
        styles: r
      });

    case "link":
      return U.createElement(fr, {
        styles: r
      });

    case "mail":
      return U.createElement(mr, {
        styles: r
      });

    case "language":
      return U.createElement(yr, {
        styles: r
      });

    case "italic":
      return U.createElement(pr, {
        styles: r
      });

    case "password":
      return U.createElement(dr, {
        styles: r
      });

    case "par-stock":
      return U.createElement(vr, {
        styles: r
      });

    case "logout":
      return U.createElement(hr, {
        styles: r
      });

    case "number":
      return U.createElement(gr, {
        styles: r
      });

    case "mobile":
      return U.createElement(Er, {
        styles: r
      });

    case "notification":
      return U.createElement(br, {
        styles: r
      });

    case "location":
      return U.createElement(wr, {
        styles: r
      });

    case "guest":
      return U.createElement(Mr, {
        styles: r
      });

    case "hotel":
      return U.createElement(xr, {
        styles: r
      });

    case "instagram":
      return U.createElement(Ar, {
        styles: r
      });

    case "incomplete":
      return U.createElement(kr, {
        styles: r
      });

    case "user-name":
      return U.createElement(_r, {
        styles: r
      });

    case "pos-id":
      return U.createElement(Cr, {
        styles: r
      });

    case "restaurant":
      return U.createElement(Sr, {
        styles: r
      });

    case "youtube":
      return U.createElement(Ir, {
        styles: r
      });

    case "reason":
      return U.createElement(Or, {
        styles: r
      });

    case "price":
      return U.createElement(jr, {
        styles: r
      });

    case "zip-code":
      return U.createElement(Pr, {
        styles: r
      });

    case "position":
      return U.createElement(Rr, {
        styles: r
      });

    case "website":
      return U.createElement(Br, {
        styles: r
      });

    case "to-right":
      return U.createElement(Vr, {
        styles: r
      });

    case "stand-by":
      return U.createElement(zr, {
        styles: r
      });

    case "to-left":
      return U.createElement($r, {
        styles: r
      });

    case "role":
      return U.createElement(Hr, {
        styles: r
      });

    case "pos":
      return U.createElement(Lr, {
        styles: r
      });

    case "star":
      return U.createElement(Zr, {
        styles: r
      });

    case "path347":
      return U.createElement(Tr, {
        styles: r
      });

    case "validation":
      return U.createElement(Nr, {
        styles: r
      });

    case "permission":
      return U.createElement(Dr, {
        styles: r
      });

    case "user":
      return U.createElement(Fr, {
        styles: r
      });

    case "title":
      return U.createElement(Ur, {
        styles: r
      });

    case "to-center":
      return U.createElement(qr, {
        styles: r
      });

    case "cake":
      return U.createElement(Je, {
        styles: r
      });

    case "dessert":
      return U.createElement(Xe, {
        styles: r
      });

    case "brunch":
      return U.createElement(Ke, {
        styles: r
      });

    case "second-brunch":
      return U.createElement(Qe, {
        styles: r
      });

    case "print":
      return U.createElement(et, {
        styles: r
      });

    case "drink":
      return U.createElement(tt, {
        styles: r
      });

    case "lunch":
      return U.createElement(rt, {
        styles: r
      });

    case "dinner":
      return U.createElement(nt, {
        styles: r
      });

    case "second-drink":
      return U.createElement(at, {
        styles: r
      });

    case "menu-item":
      return U.createElement(lt, {
        styles: r
      });

    case "wine":
      return U.createElement(st, {
        styles: r
      });

    case "wines":
      return U.createElement(ct, {
        styles: r
      });

    case "tags":
      return U.createElement(ot, {
        styles: r
      });

    default:
      return U.createElement("img", {
        src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABHNCSVQICAgIfAhkiAAAAYRJREFUaEPtln2LgkAQxsdEDF9AIkX9/p8tUyGEUPG1YwLlrqvrdmcigtl/3Xn5Pc/srsb5fL7ABy9DAN7snjjwZgNAHBAHiArICBEFJIeLA2QJiQnEAaKA5HBxgCwhMYE4QBSQHM7iQNd10LYt+L4PpmmSm1JJQAaY5xmyLFtrpmkKhmGo9EDaSwYYhgGKolibSJIENpsNqSmVYDIAFivLEhBku93Cbre7W79pGnAcR6W3f+1lAXhWaZomOB6P8Ap3XgJwq3ae5zCOI1iWBVEUPeNV+s4OsBzqOI6vN1Jd11BV1drUfr8H27aVmvxrMzsAnoe+769qh2EIh8PhR328ofCm4lqsALc30qMmXdeFIAhYGFgB8D3AEcKFM386nR7O/DJiVAo2gNtZx1FCGFTb87xffXIdaDaA7wcVr00EWhb+Ytx7nTl+PdgAqKOgGy8AuspxxYkDXErq5hEHdJXjihMHuJTUzSMO6CrHFScOcCmpm0cc0FWOK04c4FJSN8/HO/AFGEMewAwBtqsAAAAASUVORK5CYII=",
        alt: "default"
      });
  }
};

Wr.propTypes = {
  icon: Ve.string,
  styles: Ve.object
};
export { it as AddCommentIcon, ut as AddIcon, Ye as Adduser, ft as AlertIcon, Zt as AlignCenterIcon, Tt as AlignLeftIcon, Nt as AlignRightIcon, mt as ArchiveIcon, Dt as ArchivedIcon, yt as ArrangeIcon, pt as ArrowDownIcon, dt as ArrowLeftIcon, vt as ArrowRightIcon, ht as ArrowUpIcon, Ft as BoldIcon, Ke as BrunchIcon, Je as CakeIcon, qt as CalendarIcon, Wt as CardIcon, Yt as ChevronDownIcon, Gt as ChevronLeftIcon, Jt as ChevronRightIcon, Ut as ChevronUpIcon, lr as ClockIcon, cr as CommentIcon, Kt as CompleteIcon, sr as ConciergeIcon, gt as CopyDownIcon, We as DeleteIcon, Xe as DessertIcon, nt as DinnerIcon, Et as DownloadIcon, bt as DragIcon, tt as DrinkIcon, wt as DuplicateIcon, or as DutiesIcon, Ge as EditIcon, Xt as EstateIcon, Qt as ExperienceIcon, ir as ExpirationIcon, Mt as ExportIcon, er as EyeIconOff, tr as EyeIconOn, rr as FacebookIcon, nr as FontIcon, ar as FooterSectionNameIcon, xt as GalleryIcon, qe as GoToIcon, Mr as GuestIcon, At as HidePassIcon, xr as HotelIcon, Rt as ImageIcon, kr as IncompleteIcon, Ar as InstagramIcon, pr as ItalicIcon, Pt as ItemsHistoryIcon, ur as ItemsIcon, yr as LanguageIcon, fr as LinkIcon, jt as ListIcon, wr as LocationIcon, hr as LogoutIcon, rt as LunchIcon, mr as MailIcon, lt as MenuItemIcon, Er as MobileIcon, Ot as MoveDownIcon, It as MoveUpIcon, Ht as NotFoundIcon, br as NotificationsIcon, gr as NumberIcon, zt as OkIcon, vr as ParStockIcon, dr as PasswordIcon, Tr as Path347, Dr as PermissionIcon, Lr as PosIcon, Cr as PosIdIcon, Rr as PositionIcon, jr as PriceIcon, et as PrintIcon, Or as ReasonIcon, St as ReloadIcon, Vt as RemoveIcon, Sr as RestaurantIcon, Hr as RoleIcon, Ct as SearchIcon, Qe as SecondBrunchIcon, at as SecondDrinkIcon, _t as ShowPassIcon, zr as StandByIcon, Zr as StarIcon, $t as SuccessfulIcon, ot as TagsIcon, Lt as TiangleAlertIcon, Ur as TitleIcon, qr as ToCenterIcon, $r as ToLeftIcon, Vr as ToRightIcon, kt as UpdateIcon, Fr as UserIcon, _r as UserNameIcon, Nr as ValidationIcon, Br as WebsiteIcon, st as WineIcon, ct as WinesIcon, Bt as WrongIcon, Ir as YoutubeIcon, Pr as ZipcodeIcon, Wr as default };